// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tnPage {
  min-height: calc(100vh - 64px);
  background: var(--surface-page, #f6f8fb);
  color: var(--text-body, #172033);
  font-family: var(--font-body, inherit);
}
.tnTopbar {
  height: 62px;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 0 24px;
  border-bottom: 1px solid var(--border-subtle, #dbe4ef);
  background: var(--surface-card, #fff);
}
.tnBreadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-muted, #64748b);
  font-size: 14px;
}
.tnBreadcrumb i,
.tnDrawerHead i {
  width: 4px;
  height: 4px;
  border-radius: 999px;
  background: var(--text-subtle, #94a3b8);
}
.tnBreadcrumb b {
  color: var(--text-strong, #172033);
  font-weight: 650;
}
.tnPending {
  position: relative;
  margin-left: auto;
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-subtle, #dbe4ef);
  border-radius: 9px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
}
.tnPending span {
  position: absolute;
  top: -5px;
  right: -5px;
  min-width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  border-radius: 999px;
  background: #e5484d;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}
.tnMain {
  max-width: 1180px;
  padding: 24px 28px 48px;
}
.tnTitleBlock {
  margin-bottom: 18px;
}
.tnTitleBlock h1 {
  margin: 0;
  color: var(--text-strong, #172033);
  font-size: 24px;
  line-height: 30px;
  font-weight: 800;
  letter-spacing: 0;
}
.tnTitleBlock p,
.tnToolbar p {
  margin: 3px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 14px;
  line-height: 20px;
}
.tnTabs {
  display: flex;
  align-items: flex-end;
  gap: 22px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  border-bottom: 1px solid var(--border-subtle, #dbe4ef);
  margin-bottom: 16px;
}
.tnTabs::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}
.tnTabs button {
  position: relative;
  min-height: 42px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 0;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-size: 14px;
  font-weight: 650;
  cursor: pointer;
  white-space: nowrap;
}
.tnTabs button.isActive {
  color: var(--text-strong, #172033);
}
.tnTabs button.isActive::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 2px;
  border-radius: 999px;
  background: var(--action-primary, #227ebd);
}
.tnTabs span,
.tnArchiveSegment span,
.tnColumnsBtn span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--slate-200, #e2e8f0);
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 750;
}
.tnToolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 16px;
  margin-bottom: 16px;
}
.tnToolbarMain {
  flex: 1 1 220px;
}
.tnToolbarMain h2 {
  margin: 0;
  color: var(--text-strong, #172033);
  font-size: 18px;
  line-height: 24px;
  font-weight: 750;
}
.tnToolbarMain span {
  color: var(--text-muted, #64748b);
  font-size: 13px;
}
.tnToolbarActions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.tnSearch,
.tnToolbar select,
.tnColumnsBtn {
  height: 38px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--border-default, #d7e0ea);
  border-radius: 9px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #172033);
  font-size: 13px;
}
.tnSearch {
  width: 230px;
  padding: 0 11px;
  color: var(--text-muted, #64748b);
}
.tnSearch input {
  min-width: 0;
  width: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--text-body, #172033);
  font-size: 14px;
}
.tnToolbar select {
  min-width: 140px;
  padding: 0 28px 0 10px;
}
.tnColumns {
  position: relative;
}
.tnColumnsBtn {
  padding: 0 12px;
  cursor: pointer;
  font-weight: 650;
}
.tnColumnsBtn.isOpen,
.tnColumnsBtn:hover {
  border-color: var(--border-brand, #227ebd);
  background: var(--surface-brand-subtle, #eef6fc);
  color: #227ebd;
}
.tnColumnsMenu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  z-index: 30;
  width: 244px;
  padding: 8px;
  border: 1px solid var(--border-subtle, #dbe4ef);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.16);
}
.tnColumnsMenuHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px 8px;
}
.tnColumnsMenuHead strong {
  color: var(--text-muted, #64748b);
  font-size: 11px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
.tnColumnsMenuHead button {
  border: 0;
  background: transparent;
  color: #227ebd;
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}
.tnColumnOption {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--text-body, #172033);
  font-size: 13px;
  text-align: left;
  cursor: pointer;
}
.tnColumnOption:hover {
  background: var(--surface-hover, #f8fafc);
}
.tnColumnOption.isLocked {
  color: var(--text-subtle, #94a3b8);
  cursor: default;
}
.tnColumnOption em {
  margin-left: auto;
  font-size: 11px;
  font-style: normal;
}
.tnColumnCheck {
  width: 17px;
  height: 17px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid var(--border-strong, #cbd5e1);
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  line-height: 1;
}
.tnColumnCheck.isChecked {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
}
.tnArchiveSegment {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  margin-bottom: 16px;
  border-radius: 10px;
  background: var(--slate-100, #f1f5f9);
}
.tnArchiveSegment button {
  height: 32px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0 13px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  font-weight: 650;
  cursor: pointer;
}
.tnArchiveSegment button.isActive {
  background: var(--surface-card, #fff);
  color: var(--text-strong, #172033);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.14);
}
.tnArchiveSegment button.isActive span {
  background: #227ebd;
  color: #fff;
}
.tnSelection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  padding: 10px 12px;
  border: 1px solid #cfe0ff;
  border-radius: 10px;
  background: #f4f8ff;
}
.tnSelection div {
  display: flex;
  gap: 8px;
}
.tnBtn {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border-radius: 9px;
  padding: 7px 12px;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  cursor: pointer;
}
.tnBtnPrimary {
  border: 1px solid #227ebd;
  background: #227ebd;
  color: #fff;
}
.tnBtnSecondary {
  border: 1px solid var(--border-default, #d7e0ea);
  background: #fff;
  color: #172033;
}
.tnBtnGhost {
  border: 1px solid transparent;
  background: transparent;
  color: #475569;
}
.tnTableCard {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #dbe4ef);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
.tnTableScroll {
  width: 100%;
  overflow-x: auto;
}
.tnTable {
  width: 100%;
  min-width: 940px;
  border-collapse: separate;
  border-spacing: 0;
}
.tnTable th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 10px 16px;
  border-bottom: 1px solid var(--border-subtle, #dbe4ef);
  background: var(--slate-50, #f8fafc);
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-align: left;
  text-transform: uppercase;
  white-space: nowrap;
}
.tnTable th.isSortable {
  cursor: pointer;
}
.tnTable th > span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.tnTable td {
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-subtle, #edf2f7);
  color: var(--text-body, #172033);
  font-size: 13px;
  vertical-align: middle;
}
.tnTable tbody tr {
  cursor: pointer;
  transition: background 0.12s ease;
}
.tnTable tbody tr:hover,
.tnTable tbody tr.isPreview {
  background: #eef6fc;
}
.tnTable tbody tr:last-child td {
  border-bottom: 0;
}
.tnCheck {
  width: 1%;
  padding-right: 0 !important;
  text-align: center !important;
}
.tnCheck input {
  width: 17px;
  height: 17px;
  accent-color: #227ebd;
}
.tnName strong {
  display: block;
  color: var(--text-strong, #172033);
  font-size: 13.5px;
  font-weight: 650;
}

.tnName__title {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
}

.tnPublicSiteIcon {
  display: inline-flex;
  width: 26px;
  height: 26px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd9e5;
  border-radius: 7px;
  background: #f7fbfd;
  color: #1a6da3;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;
}

.tnPublicSiteIcon:hover,
.tnPublicSiteIcon:focus-visible {
  border-color: #1a6da3;
  background: #eaf6fb;
  color: #124f76;
  text-decoration: none;
}
.tnName small {
  display: block;
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
}
.tnName__meta {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  color: #667085;
  font-size: 11.5px;
}
.tnName__meta i {
  width: 9px;
  height: 9px;
  flex: 0 0 9px;
  border-radius: 2px;
}
.tnName__meta b {
  color: #c3cad5;
  font-weight: 400;
}
.tnQueue,
.tnStatus,
.tnKindPill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 22px;
  border-radius: 999px;
  padding: 3px 8px;
  background: var(--slate-100, #f1f5f9);
  color: #334155;
  font-size: 11.5px;
  font-style: normal;
  font-weight: 650;
  text-align: center;
}
.tnDate,
.tnVenue {
  white-space: nowrap;
}
.tnDeadline {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 96px;
}
.tnDeadline strong {
  color: #172033;
  font-size: 13px;
  font-weight: 650;
  white-space: nowrap;
}
.tnDeadline small {
  color: #64748b;
  font-size: 11px;
  font-weight: 650;
  white-space: nowrap;
}
.tnDeadline.isSoon small {
  color: #b42318;
}
.tnKindPill--invite {
  background: #ecfeff;
  color: #0e7490;
}
.tnKindPill--request {
  background: #f0fdf4;
  color: #15803d;
}
.tnKindPill--tournament {
  background: #eef4ff;
  color: #1d4ed8;
}
.tnStatus--success {
  background: #ecfdf3;
  color: #067647;
}
.tnStatus--info {
  background: #eef4ff;
  color: #1d4ed8;
}
.tnStatus--warning {
  background: #fff7ed;
  color: #c2410c;
}
.tnStatus--danger {
  background: #fef3f2;
  color: #b42318;
}
.tnStatus--neutral {
  background: #f1f5f9;
  color: #475569;
}
.tnEmpty {
  height: 132px;
  color: #64748b !important;
  text-align: center;
}
.tnSort {
  display: inline-flex;
  width: 8px;
  height: 12px;
  position: relative;
  color: #cbd5e1;
}
.tnSort::before,
.tnSort::after {
  content: '';
  position: absolute;
  left: 1px;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
}
.tnSort::before {
  top: 1px;
  border-bottom: 4px solid currentColor;
}
.tnSort::after {
  bottom: 1px;
  border-top: 4px solid currentColor;
}
.tnSort.isasc::before,
.tnSort.isdesc::after {
  color: #227ebd;
}
.tnDrawerBackdrop {
  position: fixed;
  inset: 0;
  z-index: 1040;
  border: 0;
  background: rgba(15, 23, 42, 0.28);
  backdrop-filter: blur(2px);
  cursor: default;
}
.tnDrawer {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1041;
  width: min(460px, 100vw);
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--surface-card, #fff);
  box-shadow: -18px 0 42px rgba(15, 23, 42, 0.2);
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}
.tnDrawerHead {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr) 34px;
  gap: 12px;
  align-items: start;
  padding: 20px 22px;
  border-bottom: 1px solid var(--border-subtle, #dbe4ef);
  background: linear-gradient(180deg, #fff 0%, #fbfdff 100%);
}
.tnDrawerHead h2 {
  margin: 0;
  color: var(--text-heading, #0f172a);
  font-family: var(--font-heading, var(--font-display, 'Hanken Grotesk', system-ui, sans-serif));
  font-size: 20px;
  line-height: 26px;
  font-weight: 850;
}
.tnDrawerHead p {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 5px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
}
.tnDrawerHead button {
  width: 34px;
  height: 34px;
  border: 1px solid var(--border-default, #d7e0ea);
  border-radius: 9px;
  background: #fff;
  color: #475569;
  font-size: 21px;
  line-height: 28px;
  cursor: pointer;
}
.tnDrawerHead button:hover {
  background: var(--surface-subtle, #f8fafc);
  color: var(--text-heading, #0f172a);
}
.tnDrawerIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
}
.tnKind--waiting {
  background: #fff7ed;
  color: #c2410c;
}
.tnKind--invite {
  background: #ecfeff;
  color: #0e7490;
}
.tnKind--request {
  background: #f0fdf4;
  color: #15803d;
}
.tnKind--tournament {
  background: #eef4ff;
  color: #0f5fff;
}
.tnDrawerBody {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 20px 22px;
  background: var(--surface-subtle, #f8fafc);
}
.tnDrawerTabs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
  padding: 10px 22px;
  border-bottom: 1px solid var(--border-subtle, #dbe4ef);
  background: #fff;
}
.tnDrawerTabs button {
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 7px 10px;
  border: 1px solid transparent;
  border-radius: 9px;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
  font-weight: 750;
  cursor: pointer;
}
.tnDrawerTabs button:hover {
  background: #f5f8fb;
  color: var(--text-heading, #0f172a);
}
.tnDrawerTabs button.isActive {
  border-color: #cfe3f2;
  background: #eef6fc;
  color: #155d8c;
}
.tnDrawerTabs button span {
  min-width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border-radius: 999px;
  background: #227ebd;
  color: #fff;
  font-size: 10px;
}
.tnDrawerBody--updates {
  padding: 0;
}
.tnDrawerBody--updates .bTournamentAdditionalInfo {
  padding: 16px;
}
.tnDrawerBody--updates .eAdditionalInfoSection {
  border-color: #dbe4ef;
  background: #f8fafc;
}
.tnDrawerBody--updates .eAdditionalInfoSectionHeader {
  padding: 16px;
}
.tnDrawerBody--updates .eAdditionalInfoList {
  padding: 12px;
}
.tnDrawerBody--updates .bAnnounce {
  padding: 16px;
  border-radius: 12px;
}
.tnDrawerBody--updates .eAnnounceMain {
  gap: 14px;
}
.tnDrawerBody--updates .eAnnounceMain--withMedia {
  grid-template-columns: 92px minmax(0, 1fr);
}
.tnDrawerBody--updates .eAnnounceImageThumbButton {
  width: 92px;
  height: 92px;
  border-radius: 10px;
}
.tnDrawerBody--updates .eAnnounceTitle {
  font-size: 17px;
}
.tnDrawerBody--updates .eAnnounceAttachmentCard {
  align-items: flex-start;
  flex-direction: column;
}
.tnDrawerNotice,
.tnDrawerContext {
  display: flex;
  gap: 10px;
  padding: 12px 14px;
  margin-bottom: 12px;
  border-radius: 9px;
  border: 1px solid #cfe0ff;
  background: #f4f8ff;
  color: #1d4ed8;
  font-size: 13px;
  line-height: 18px;
}
.tnDrawerNotice.isSoon {
  border-color: #fed7aa;
  background: #fff7ed;
  color: #c2410c;
}
.tnDrawerContext {
  display: block;
  color: #1c4e73;
  background: #eef5fb;
  border-color: #cfe1f2;
}
.tnDrawerContext.isWaiting {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 11px;
  padding: 14px;
  border-color: #f1d49a;
  background: #fffaf0;
  color: #71551e;
}
.tnDrawerContext.isWaiting > span {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f4b740;
  color: #fff;
  font-size: 13px;
  font-weight: 900;
}
.tnDrawerContext.isWaiting strong {
  display: block;
  margin: 1px 0 4px;
  color: #7a4b08;
  font-size: 13px;
  font-weight: 800;
}
.tnDrawerContext.isWaiting p {
  margin: 0;
  color: #71551e;
  font-size: 12.5px;
  line-height: 1.5;
}
.tnDrawerContext.isParticipant {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 11px;
  padding: 14px;
  border-color: #bfe4cd;
  background: #f1fbf5;
  color: #17653a;
}
.tnDrawerContext.isParticipant > span {
  width: 26px;
  height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #21874d;
  color: #fff;
}
.tnDrawerContext.isParticipant strong {
  display: block;
  margin: 1px 0 4px;
  color: #155f37;
  font-size: 13px;
  font-weight: 800;
}
.tnDrawerContext.isParticipant p {
  margin: 0;
  color: #277149;
  font-size: 12.5px;
  line-height: 1.5;
}
.tnDrawerSectionTitle {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 18px 0 9px;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.tnDrawerSectionTitle::after {
  content: '';
  flex: 1 1 auto;
  height: 1px;
  background: var(--border-subtle, #e2e8f0);
}
.tnDrawerDetails {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #fff);
}
.tnDrawerField {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
  padding: 13px 14px;
  border-bottom: 1px solid var(--border-subtle, #edf2f7);
}
.tnDrawerField:nth-child(odd) {
  border-right: 1px solid var(--border-subtle, #edf2f7);
}
.tnDrawerField:nth-last-child(-n + 2) {
  border-bottom: 0;
}
.tnDrawerField > span {
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.tnDrawerField strong {
  color: var(--text-strong, #172033);
  font-size: 14px;
  line-height: 20px;
  font-weight: 650;
  overflow-wrap: anywhere;
}

.tnPublicSiteLink {
  display: flex;
  min-height: 58px;
  align-items: center;
  gap: 11px;
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid #cfe3f2;
  border-radius: 11px;
  background: #f4f9fd;
  color: var(--text-body, #334155);
  text-decoration: none;
}

.tnPublicSiteLink:hover,
.tnPublicSiteLink:focus-visible {
  border-color: #8dbbd9;
  background: #eef6fc;
  color: var(--text-body, #334155);
  outline: none;
  text-decoration: none;
}

.tnPublicSiteLink__icon {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #ddecf7;
  color: var(--blue-700, #155d8c);
}

.tnPublicSiteLink > span:nth-child(2) {
  min-width: 0;
  flex: 1 1 auto;
}

.tnPublicSiteLink small,
.tnPublicSiteLink strong {
  display: block;
}

.tnPublicSiteLink small {
  margin-bottom: 2px;
  color: var(--text-muted, #64748b);
  font-size: 10.5px;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.tnPublicSiteLink strong {
  overflow: hidden;
  color: var(--text-strong, #0f172a);
  font-size: 13px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tnPublicSiteLink > b {
  display: inline-flex;
  min-height: 32px;
  flex: 0 0 auto;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  border-radius: 8px;
  background: var(--blue-600, #227ebd);
  color: #fff;
  font-size: 12px;
  font-weight: 750;
}
.tnDrawerFoot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 22px;
  border-top: 1px solid var(--border-subtle, #dbe4ef);
  background: #fbfdff;
}
.tnDrawerActions {
  width: 100%;
}
.tnDrawerActions__main {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
}
.tnDrawerActions__main.hasTeamManagement > .tnBtnPrimary {
  grid-column: 1 / -1;
}
.tnDrawerActions__main .tnBtn {
  min-height: 42px;
}
.tnInviteActions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
}
.tnInviteActions button {
  min-height: 40px;
  padding: 0 15px;
  border: 1px solid #227ebd;
  border-radius: 8px;
  background: #227ebd;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
}
.tnInviteActions button:hover {
  background: #176da8;
}
.tnInviteActions button.is-danger {
  border-color: transparent;
  background: var(--red-500, #da4453);
}
.tnInviteActions button.is-danger:hover {
  background: var(--red-600, #c4313f);
}
.tnDrawerActions__help {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin: 9px 2px 0;
  color: #64748b;
  font-size: 12px;
  line-height: 17px;
}
.tnDrawerActions__help svg {
  flex: 0 0 auto;
  margin-top: 1px;
}
.tnDrawerActions__help.isempty {
  color: #775b20;
}
.tnDrawerActions__help.iserror {
  color: #a43a43;
}
.tnDrawer .tnDrawerActions__withdraw {
  width: 100%;
  min-height: 40px;
  margin-top: 14px;
  border-color: var(--red-500, #c4313f);
  background: var(--red-500, #c4313f);
  color: #fff;
  font-weight: 750;
}
.tnDrawer .tnDrawerActions__withdraw:hover:not(:disabled) {
  border-color: var(--red-600, #a92734);
  background: var(--red-600, #a92734);
  color: #fff;
}
.tnBtnWithIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
}
.tnDrawer.isWaiting .tnDrawerFoot .tnBtnDanger {
  min-height: 40px;
  padding: 0 15px;
  border-color: var(--red-500, #c4313f);
  background: var(--red-500, #c4313f);
  color: #fff;
  font-weight: 750;
}
.tnDrawer.isWaiting .tnDrawerFoot .tnBtnDanger:hover:not(:disabled) {
  background: var(--red-600, #a92734);
}
@media (max-width: 760px) {
  .tnTopbar {
    padding: 0 14px;
  }
  .tnMain {
    padding: 18px 14px 32px;
  }
  .tnToolbarActions,
  .tnSearch,
  .tnToolbar select,
  .tnColumns {
    width: 100%;
  }
  .tnColumnsBtn {
    width: 100%;
    justify-content: center;
  }
  .tnArchiveSegment {
    width: 100%;
    overflow-x: auto;
  }
}
.tnBtnDanger {
  border-color: #fecaca;
  background: #fff;
  color: #b42318;
}
.tnBtnDanger:hover:not(:disabled) {
  background: #fef3f2;
}
.tnBtn:disabled {
  cursor: not-allowed;
  border-color: #e2e8f0;
  background: #f1f5f9;
  color: #94a3b8;
  opacity: 1;
}
.tnModalBackdrop {
  position: fixed;
  inset: 0;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  background: rgba(15, 23, 42, 0.38);
  backdrop-filter: blur(3px);
}

.tnModalBackdrop--aboveModal {
  z-index: 1060;
}
.tnModal {
  width: min(520px, 100%);
  overflow: hidden;
  border: 0;
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #fff);
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.24);
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}
.tnModalHead {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 13px;
  padding: 20px 22px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: linear-gradient(180deg, #fff 0%, #fbfdff 100%);
}
.tnModalHead h3 {
  margin: 0;
  color: var(--text-heading, #0f172a);
  font-family: var(--font-heading, var(--font-display, 'Hanken Grotesk', system-ui, sans-serif));
  font-size: 19px;
  line-height: 24px;
  font-weight: 850;
}
.tnModalHead p {
  margin: 3px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
  font-weight: 550;
  line-height: 1.4;
}
.tnModalIcon {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md, 8px);
  background: #fff1f2;
  color: var(--red-600, #c4313f);
}
.tnModal.isSuccess .tnModalIcon {
  border-radius: 50%;
  background: #e8f7ee;
  color: #21874d;
}
.tnModal.isWarning .tnModalIcon {
  background: #fff8e8;
  color: #b7791f;
}
.tnModalHead button {
  width: 32px;
  height: 32px;
  border: 1px solid var(--border-default, #d7e0ea);
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 20px;
  line-height: 26px;
  cursor: pointer;
}
.tnModalHead button:hover:not(:disabled) {
  background: var(--surface-subtle, #f8fafc);
  color: var(--text-heading, #0f172a);
}
.tnModalBody {
  padding: 22px;
  color: var(--text-default, #334155);
  font-size: 14px;
  line-height: 21px;
}
.tnModalMessage {
  padding: 14px 15px;
  border: 1px solid #ffd5da;
  border-radius: var(--radius-md, 8px);
  background: #fff5f6;
  color: #9f2430;
  font-size: 13px;
  font-weight: 650;
  line-height: 1.5;
}
.tnModal.isSuccess .tnModalMessage {
  border-color: #bfe4cd;
  background: #f1fbf5;
  color: #17653a;
}
.tnModal.isWarning .tnModalMessage {
  border-color: #f1d49a;
  background: #fffaf0;
  color: #71551e;
}
.tnModalError {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #fecaca;
  background: #fef3f2;
  color: #b42318;
  font-size: 13px;
}
.tnModalFoot {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  padding: 16px 22px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  background: #fbfdff;
}
.tnModal.isDanger .tnModalFoot .tnBtnDanger {
  min-height: 40px;
  padding: 0 15px;
  border-color: var(--red-500, #c4313f);
  background: var(--red-500, #c4313f);
  color: #fff;
  font-weight: 750;
}
.tnModal.isDanger .tnModalFoot .tnBtnDanger:hover:not(:disabled) {
  background: var(--red-600, #a92734);
}
@media (max-width: 560px) {
  .tnDrawerDetails {
    grid-template-columns: 1fr;
  }
  .tnDrawerField,
  .tnDrawerField:nth-child(odd),
  .tnDrawerField:nth-last-child(-n + 2) {
    border-right: 0;
    border-bottom: 1px solid var(--border-subtle, #edf2f7);
  }
  .tnDrawerField:last-child {
    border-bottom: 0;
  }
  .tnDrawerFoot .tnBtn,
  .tnModalFoot .tnBtn {
    width: 100%;
  }
  .tnDrawerActions__main {
    grid-template-columns: 1fr;
  }
  .tnModalFoot {
    flex-direction: column-reverse;
  }
}
.tnToolbar {
  display: block;
  margin-bottom: 16px;
}
.tnToolbarHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 6px;
}
.tnFilterPanel {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px;
  margin-top: 12px;
  padding: 12px;
  border: 1px solid var(--border-subtle, #dbe4ef);
  border-radius: 10px;
  background: var(--surface-card, #fff);
}
.tnFilterPanel label {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 150px;
}
.tnFilterPanel label > span {
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.tnFilterPanel select,
.tnFilterPanel input[type='date'] {
  height: 38px;
  border: 1px solid var(--border-default, #d7e0ea);
  border-radius: 9px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #172033);
  font-size: 13px;
}
.tnFilterPanel select {
  min-width: 150px;
  padding: 0 28px 0 10px;
}
.tnFilterPanel input[type='date'] {
  min-width: 155px;
  padding: 0 10px;
}
.tnFilterColumns {
  position: relative;
}
.tnFilterReset {
  min-height: 38px;
}
.tnPagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
}
.tnPagination > div {
  display: flex;
  align-items: center;
  gap: 6px;
}
.tnPageBtn {
  min-width: 34px;
  height: 34px;
  padding: 0 10px;
  border: 1px solid var(--border-default, #d7e0ea);
  border-radius: 8px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #172033);
  font-size: 13px;
  font-weight: 650;
  cursor: pointer;
}
.tnPageBtn.isActive {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}
.tnPageBtn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}
.tnPageGap {
  padding: 0 2px;
  color: var(--text-muted, #64748b);
}
.tnPageSummary {
  display: flex;
  align-items: center;
  gap: 12px;
}
.tnPageSummary label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
}
.tnPageSummary select {
  height: 32px;
  border: 1px solid var(--border-default, #d7e0ea);
  border-radius: 8px;
  background: #fff;
  color: var(--text-body, #172033);
}
@media (max-width: 760px) {
  .tnToolbarHead,
  .tnPagination,
  .tnPageSummary {
    align-items: stretch;
    flex-direction: column;
  }
  .tnFilterPanel label,
  .tnFilterPanel select,
  .tnFilterPanel input[type='date'],
  .tnFilterColumns,
  .tnFilterReset {
    width: 100%;
  }
  .tnPagination > div {
    flex-wrap: wrap;
  }
}
.tnToolbar {
  display: block;
  margin-bottom: 16px;
}
.tnToolbarHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 6px;
}
.tnToolbarControls {
  display: flex;
  align-items: center;
  gap: 8px;
}
.tnSectionTitleRow {
  display: flex;
  align-items: center;
  gap: 10px;
}
.tnResponseBadge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  background: #fef3f2;
  color: #b42318;
  font-size: 12px;
  font-weight: 800;
}
.tnIconBtn {
  position: relative;
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-default, #d7e0ea);
  border-radius: 9px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  cursor: pointer;
}
.tnIconBtn:hover,
.tnIconBtn.isOn {
  border-color: var(--border-brand, #227ebd);
  background: var(--surface-brand-subtle, #eef6fc);
  color: #227ebd;
}
.tnIconBtnDot {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 7px;
  height: 7px;
  border: 1.5px solid #fff;
  border-radius: 50%;
  background: #f08c1a;
}
.tnMaskedIcon {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  display: inline-block;
  background: currentColor;
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: 16px 16px;
  -webkit-mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: 16px 16px;
}
.tnMaskedIcon--filter {
  mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E");
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E");
}
.tnMaskedIcon--columns {
  mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E");
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E");
}
.tnColumnsBtn {
  height: 38px;
}
.tnFilterPanel {
  margin-top: 12px;
}
.tnToolbarMain {
  flex: 1 1 auto;
  min-width: 0;
}
.tnSectionTitleRow {
  flex-wrap: wrap;
}
.tnSectionTitleRow .tnSearch {
  margin-left: 2px;
  margin-bottom: 0;
}
@media (max-width: 760px) {
  .tnSectionTitleRow {
    align-items: stretch;
    flex-direction: column;
  }
  .tnSectionTitleRow .tnSearch,
  .tnSectionTitleRow .tnColumns,
  .tnSectionTitleRow .tnColumnsBtn,
  .tnSectionTitleRow .tnIconBtn {
    width: 100%;
  }
}
.tnSectionTitleRow {
  align-items: flex-end;
}
.tnSectionTitleRow h2,
.tnResponseBadge {
  margin-bottom: 1px;
}
.tnSectionTitleRow .tnIconBtn,
.tnSectionTitleRow .tnColumnsBtn,
.tnSectionTitleRow .tnSearch {
  height: 40px;
}
@media (max-width: 760px) {
  .tnSectionTitleRow {
    align-items: stretch;
  }
  .tnSectionTitleRow h2,
  .tnResponseBadge {
    margin-bottom: 0;
  }
}
.tnDateRangePicker {
  min-width: 260px;
}
.tnFilterPanel .tnDateRangePicker .sit-dp__label {
  display: block;
  width: 100%;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-align: left;
}
.tnFilterPanel .tnDateRangePicker .sit-dp__trigger {
  height: 38px;
  border-color: var(--border-default, #d7e0ea);
  border-radius: 9px;
  font-size: 13px;
}
@media (max-width: 760px) {
  .tnDateRangePicker {
    width: 100%;
    min-width: 0;
  }
}

/* List filters handoff: tournament lists use the large right-side drawer. */
.tnSectionTitleRow .tnIconBtn {
  width: auto;
  min-width: 92px;
  gap: 7px;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 700;
}

.tnSectionTitleRow .tnIconBtn b {
  display: inline-flex;
  min-width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  border-radius: 999px;
  background: #227ebd;
  color: #fff;
  font-size: 10px;
}

.tnFilterPanel {
  position: fixed;
  z-index: 1060;
  top: 0;
  right: 0;
  bottom: 0;
  left: auto;
  display: flex;
  width: 360px;
  max-width: calc(100vw - 20px);
  height: auto;
  max-height: none;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
  border: 0;
  border-left: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 0;
  background: #fff;
  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);
}

.tnFilterPanel > header {
  display: flex;
  min-height: 34px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  margin: 18px 18px 0;
  padding: 0 0 12px !important;
  border-bottom: 1px solid var(--border-subtle, #e7edf3);
}

.tnFilterPanel > header strong {
  color: var(--text-strong, #142033);
  font-size: 16px;
  font-weight: 800;
  line-height: 1.3;
}

.tnFilterPanel > header button {
  width: 30px;
  min-width: 30px;
  height: 30px;
  min-height: 30px;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #667085;
  font-size: 22px;
  font-weight: 400;
  line-height: 1;
}

.tnFilterPanel__body {
  display: grid;
  min-height: 0;
  flex: 1 1 auto;
  align-content: start;
  grid-template-columns: 1fr;
  grid-auto-rows: max-content;
  gap: 16px;
  padding: 18px 18px 22px;
  overflow-y: auto;
}

.tnFilterPanel__body label,
.tnFilterPanel__body select,
.tnFilterPanel__body .tnDateRangePicker,
.tnFilterPanel__body .tnFilterReset {
  width: 100%;
  min-width: 0;
}

.tnFilterPanel__body .sit-dp__trigger,
.tnFilterPanel__body select {
  width: 100%;
  height: 40px;
}

.tnFilterPanel > footer {
  display: flex;
  min-height: 64px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 14px 18px;
  border-top: 1px solid var(--border-subtle, #e7edf3);
  background: #fff;
}

.tnFilterPanel > footer > div {
  display: flex;
  gap: 8px;
}

.tnFilterClear {
  min-height: 36px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #1a6da3;
  font-size: 12px;
  font-weight: 700;
}

.tnFilterPanel .sit-dp__pop {
  position: fixed;
  z-index: 1080;
  top: 50%;
  right: auto;
  bottom: auto;
  left: 50%;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 32px);
  transform: translate(-50%, -50%);
}

@media (max-width: 600px) {
  .tnFilterPanel {
    top: 0;
    left: 0;
    width: 100vw;
    max-width: none;
    height: 100vh;
  }
}

.tnActiveFilters {
  display: flex;
  min-height: 44px;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin: -4px 0 14px;
}

.tnActiveFilters span {
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  gap: 4px;
  padding: 0 10px;
  border: 1px solid #b9dff2;
  border-radius: 999px;
  background: #eef8fc;
  color: #124f76;
  font-size: 12px;
}

.tnActiveFilters button {
  border: 0;
  background: transparent;
  color: #69778a;
  font-size: 12px;
  font-weight: 700;
}

.tnConfirmationRequestDialog .modal-body {
  padding: 0 !important;
  overflow: auto;
}

.tnConfirmationRequestModal {
  min-width: 0;
  background: #fff;
  color: var(--text-strong, #142033);
}

.tnConfirmationRequestModal > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 22px 24px 18px;
  border-bottom: 1px solid var(--border-subtle, #e7edf3);
  background: #fff;
}

.tnConfirmationRequestModal > header h2 {
  margin: 0;
  color: var(--text-strong, #142033);
  font-size: 20px;
  font-weight: 800;
  line-height: 1.3;
}

.tnConfirmationRequestModal > header p {
  margin: 5px 0 0;
  color: #667085;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.45;
}

.tnConfirmationRequestModal > header button {
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: #f4f6f8;
  color: #526071;
  font-size: 23px;
  line-height: 1;
}

.tnConfirmationRequestModal__body {
  padding: 20px 24px 24px;
}

.tnConfirmationRequestModal__error {
  margin: 18px 24px 0;
  padding: 11px 13px;
  border: 1px solid #fecaca;
  border-radius: 9px;
  background: #fff1f2;
  color: #b42318;
  font-size: 13px;
  font-weight: 600;
}

.tnConfirmationRequestModal .programmeBookingModalHero,
.tnConfirmationRequestModal .programmeBookingQuestionCard {
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  box-shadow: none;
}

.tnConfirmationRequestModal .programmeBookingModalHero {
  padding: 18px;
  background: #f8fafc;
}

.tnConfirmationRequestModal .programmeBookingQuestionCard {
  padding: 16px;
  background: #fff;
}

.tnConfirmationRequestModal .form-control {
  min-height: 40px;
  border-color: #ccd5df;
  border-radius: 8px;
}

.tnConfirmationRequestModal__body > div > .d-flex.justify-content-end {
  margin-top: 20px !important;
  padding-top: 18px;
  border-top: 1px solid var(--border-subtle, #e7edf3);
}

.tnConfirmationRequestModal__body .btn {
  min-width: 104px;
  min-height: 40px;
  padding: 8px 18px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  box-shadow: none !important;
}

.tnConfirmationRequestModal__body .btn-primary {
  border-color: #1a6da3;
  background: #1a6da3;
}

@media (max-width: 600px) {
  .tnConfirmationRequestModal > header,
  .tnConfirmationRequestModal__body {
    padding-right: 16px;
    padding-left: 16px;
  }
}

/* School tournament lists: shared page shell aligned with the organiser-side reference. */
.tnPage {
  width: 100%;
  max-width: none;
  min-width: 0;
  background: var(--surface-page, #f8fafc);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.tnPageHeader {
  display: flex;
  width: calc(100% + 52px);
  height: 70px;
  min-width: 0;
  align-items: center;
  gap: 28px;
  margin: -20px -30px 0 -22px;
  padding: 0 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.tnPageHeader > h1 {
  flex: 0 0 auto;
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.015em;
  white-space: nowrap;
}

.tnPageHeader .tnTabs {
  display: flex;
  min-width: 0;
  height: 70px;
  flex: 1 1 auto;
  align-self: stretch;
  align-items: stretch;
  gap: 26px;
  margin: 0;
  overflow-x: auto;
  border: 0;
}

.tnPageHeader .tnTabs button {
  position: relative;
  height: auto;
  min-height: 0;
  flex: 0 0 auto;
  padding: 1px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 15px;
  font-weight: 650;
}

.tnPageHeader .tnTabs button::after {
  right: 0;
  bottom: 0;
  left: 0;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: transparent;
}

.tnPageHeader .tnTabs button:hover,
.tnPageHeader .tnTabs button.isActive {
  color: var(--blue-600, #1a6da3);
}

.tnPageHeader .tnTabs button.isActive::after {
  bottom: 0;
  height: 3px;
  background: var(--blue-500, #227ebd);
}

.tnPageHeader .tnTabs span {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
}

.tnPageHeader .tnTabs button.isActive span {
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.tnPageHeader .tnTabs span.tnTabs__unread {
  background: var(--amber-100, #ffedc2);
  color: var(--amber-800, #8a4b08);
}

.tnSummaryStrip {
  display: flex;
  width: calc(100% + 52px);
  min-width: 0;
  align-items: center;
  gap: 8px;
  margin: 0 -30px 0 -22px;
  padding: 10px 28px 11px;
  overflow-x: auto;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
  scrollbar-width: thin;
}

.tnSummaryChip {
  display: inline-flex;
  min-height: 34px;
  flex: 0 0 auto;
  align-items: center;
  padding: 6px 11px;
  border: 1px solid transparent;
  border-radius: 999px;
  font: inherit;
  text-align: left;
  white-space: nowrap;
  cursor: pointer;
  transition: border-color 140ms ease, filter 140ms ease, transform 140ms ease;
}

.tnSummaryChip:hover,
.tnSummaryChip:focus-visible {
  filter: brightness(0.985);
  transform: translateY(-1px);
  outline: none;
}

.tnSummaryChip__copy {
  display: inline-flex;
  min-width: 0;
  align-items: baseline;
  gap: 5px;
  white-space: nowrap;
}

.tnSummaryChip small,
.tnSummaryChip strong {
  display: inline;
  white-space: nowrap;
}

.tnSummaryChip small {
  color: inherit;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.2;
  opacity: 0.78;
}

.tnSummaryChip strong {
  color: inherit;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.2;
}

.tnSummaryChip.is-date {
  border-color: #f3d49a;
  background: #fff7e8;
  color: #8b570a;
}

.tnSummaryChip.is-upcoming {
  border-color: #c9e0f1;
  background: #eef6fc;
  color: #155d8c;
}

.tnSummaryChip.is-invites {
  border-color: #f5c9b5;
  background: #fff3ed;
  color: #a74418;
}

.tnSummaryChip.is-requests {
  border-color: #d9d1f3;
  background: #f5f2ff;
  color: #6548a8;
}

.tnSummaryChip.is-waiting {
  border-color: #bfe5d0;
  background: #eefaf3;
  color: #287447;
}

.tnMain {
  width: 100%;
  max-width: none;
  padding: 14px 12px 36px;
}

.tnListPanel {
  width: 100%;
  min-width: 0;
  overflow: visible;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-sm, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.tnListPanel .tnToolbar {
  display: block;
  margin: 0;
  padding: 14px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.tnListPanel .tnToolbarHead {
  margin: 0;
}

.tnListPanel .tnToolbarMain,
.tnListPanel .tnSectionTitleRow {
  width: 100%;
}

.tnListPanel .tnSectionTitleRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.tnListPanel .tnSectionTitleRow h2 {
  margin-right: 2px;
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 18px;
  font-weight: 800;
}

.tnListCount,
.tnResponseBadge {
  display: inline-flex;
  min-width: 24px;
  min-height: 24px;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b) !important;
  font-size: 11px !important;
  font-weight: 800 !important;
}

.tnListPanel .tnSearch {
  position: relative;
  width: min(320px, 100%);
  height: 40px;
  margin-left: 4px;
  padding: 0 38px 0 12px;
  border-color: var(--border-default, #cbd5e1);
  border-radius: 8px;
}

.tnListPanel .tnSearch:focus-within {
  border-color: var(--blue-500, #227ebd);
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.13);
}

.tnListPanel .tnSearch > button {
  position: absolute;
  top: 50%;
  right: 7px;
  display: inline-flex;
  width: 26px;
  height: 26px;
  align-items: center;
  justify-content: center;
  padding: 0;
  transform: translateY(-50%);
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-muted, #64748b);
  cursor: pointer;
  font-size: 18px;
}

.tnListPanel .tnSearch > button:hover {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
}

.tnListPanel .tnIconBtn,
.tnListPanel .tnColumnsBtn {
  height: 40px;
  min-height: 40px;
  border-color: var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: #fff;
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 700;
}

.tnListPanel .tnIconBtn:hover,
.tnListPanel .tnIconBtn.isOn,
.tnListPanel .tnColumnsBtn:hover,
.tnListPanel .tnColumnsBtn.isOpen {
  border-color: var(--blue-500, #227ebd);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.tnListPanel .tnActiveFilters {
  min-height: 46px;
  margin: 0;
  padding: 8px 16px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.tnListPanel .tnActiveFilters > span {
  min-height: 28px;
  padding: 0 8px 0 10px;
  border-color: #b9dff2;
  background: #eef8fc;
  color: #124f76;
}

.tnListPanel .tnActiveFilters > span > button {
  display: inline-flex;
  width: 18px;
  min-width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: currentColor;
  font-size: 15px;
  line-height: 1;
}

.tnListPanel .tnActiveFilters > span > button:hover {
  background: rgba(21, 93, 140, 0.12);
}

.tnListPanel .tnActiveFilters > .tnActiveFilters__clear {
  padding: 0 4px;
  color: var(--blue-700, #155d8c);
  font-size: 12px;
  font-weight: 750;
}

.tnFilterChips {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.tnFilterChips legend {
  margin: 0 0 8px;
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 700;
}

.tnFilterChips > div {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.tnFilterChips button {
  min-height: 32px;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 999px;
  background: #fff;
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 650;
}

.tnFilterChips button:hover {
  border-color: #84b9d8;
  background: #f5fafc;
}

.tnFilterChips button.isSelected {
  border-color: var(--blue-500, #227ebd);
  background: var(--blue-500, #227ebd);
  color: #fff;
}

.tnListPanel .tnFilterPanel {
  box-shadow: -100vw 0 0 100vw rgba(15, 23, 42, 0.22), -12px 0 34px rgba(15, 23, 42, 0.14);
}

.tnListPanel .tnBtnPrimary:hover:not(:disabled) {
  border-color: var(--blue-700, #155d8c);
  background: var(--blue-700, #155d8c);
  color: #fff;
}

.tnListPanel .tnArchiveSegment,
.tnListPanel .tnSelection {
  margin: 12px 16px;
}

.tnListPanel .tnTableCard {
  margin: 0;
  overflow: hidden;
  border-width: 1px 0 0;
  border-radius: 0;
  box-shadow: none;
}

.tnListPanel .tnTable tbody tr,
.tnListPanel .tnTable td {
  height: 56px;
}

.tnListPanel .tnTable tbody tr {
  cursor: pointer;
}

.tnListPanel .tnEmpty {
  height: 220px;
  color: var(--text-muted, #64748b);
  font-size: 14px;
  text-align: center;
}

.tnListPanel .tnListPagination .bPagination--modern {
  display: flex;
  min-height: 58px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 0;
  padding: 10px 16px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
}

@media (max-width: 600px) {
  .tnListPagination .bPagination--modern { flex-wrap: wrap; }
  .tnListPagination .bPagination__pages { flex-wrap: wrap; }
}

.tnPagination__info {
  min-width: 94px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  font-weight: 650;
  text-align: center;
}

.tnListPanel .tnPageBtn {
  min-width: 84px;
}

.tnListPanel .tnColumnsMenu {
  z-index: 1070;
  top: 46px;
}

@media (max-width: 900px) {
  .tnPageHeader {
    height: auto;
    min-height: 70px;
    flex-wrap: wrap;
    gap: 0 16px;
    padding-top: 10px;
  }

  .tnPageHeader .tnTabs {
    width: 100%;
    height: 42px;
    flex-basis: 100%;
    order: 3;
  }
}

@media (max-width: 760px) {
  .tnPageHeader {
    width: calc(100% + 44px);
    margin-right: -22px;
    margin-left: -22px;
    padding-right: 16px;
    padding-left: 16px;
  }

  .tnMain {
    padding: 10px 8px 24px;
  }

  .tnSummaryStrip {
    width: calc(100% + 44px);
    margin-right: -22px;
    margin-left: -22px;
    padding-right: 16px;
    padding-left: 16px;
  }

  .tnListPanel .tnSectionTitleRow {
    align-items: stretch;
    flex-direction: column;
  }

  .tnListPanel .tnSectionTitleRow h2,
  .tnListPanel .tnListCount,
  .tnListPanel .tnResponseBadge {
    align-self: flex-start;
  }

  .tnListPanel .tnSearch,
  .tnListPanel .tnIconBtn,
  .tnListPanel .tnColumns,
  .tnListPanel .tnColumnsBtn {
    width: 100%;
  }
}
.tnReportPicker {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 22px;
}

.tnReportDialog .modal-content {
  overflow: hidden;
  border: 0;
  border-radius: 16px;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.22);
}

.tnReportDialog .modal-body {
  padding: 0;
}

.tnReportPicker__heading {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 4px;
}

.tnReportPicker__heading > span {
  width: 42px;
  height: 42px;
  display: inline-flex;
  flex: 0 0 42px;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #eaf2ff;
  color: #2463a7;
}

.tnReportPicker h2,
.tnReportPicker p {
  margin: 0;
}

.tnReportPicker > .tnBtn {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  height: auto;
  min-height: 70px;
  align-items: center;
  justify-content: stretch;
  gap: 12px;
  padding: 14px 16px;
  text-align: left;
}

.tnReportPicker__optionIcon {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f0f5fb;
  color: #2463a7;
}

.tnReportPicker__optionIcon svg {
  display: block;
  flex: 0 0 auto;
}

.tnReportPicker__optionCopy {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  flex-direction: column;
  gap: 2px;
  line-height: 1.35;
}

.tnReportPicker__optionCopy strong,
.tnReportPicker__optionCopy small {
  display: block;
  margin: 0;
}

.tnReportPicker > .tnBtn small {
  color: #667085;
  font-size: 13px;
  font-weight: 400;
}

.tnReportDialog form {
  max-height: min(78vh, 720px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 22px 24px;
  color: #172033;
}

.tnReportDialog .bReportFormTitle {
  position: relative;
  margin: -22px -24px 18px;
  padding: 20px 54px 18px 62px;
  border-bottom: 1px solid #e7edf4;
  background: #f8fafc;
  color: #172033;
  font-size: 20px;
  font-weight: 700;
}

.tnReportDialog .bReportFormTitle::before {
  content: '';
  position: absolute;
  top: 15px;
  left: 20px;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: #eaf2ff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%232463a7' stroke-width='1.8'%3E%3Cpath d='M6 2h8l4 4v16H6zM14 2v5h5M9 12h6M9 16h6'/%3E%3C/svg%3E") center/18px no-repeat;
}

.tnReportDialog form > .mb-3.mt-3 {
  margin: 0 0 18px !important;
  color: #667085;
  font-size: 13px;
  line-height: 1.5;
}

.tnReportDialog .form-group,
.tnReportDialog .form-check {
  margin: 0 !important;
  padding: 11px 0 !important;
  border-bottom: 1px solid #eef2f6;
}

.tnReportDialog .form-group > label {
  display: block;
  margin-bottom: 6px;
  color: #344054;
  font-size: 13px;
  font-weight: 650;
}

.tnReportDialog .react-datepicker-wrapper,
.tnReportDialog .react-datepicker__input-container {
  width: 100%;
}

.tnReportDialog .form-control {
  height: 40px;
  border: 1px solid #cfd8e3;
  border-radius: 9px;
  box-shadow: none;
  font-size: 14px;
}

.tnReportDialog .tournamentReportFormModern__dateRange {
  margin-bottom: 18px;
}

.tnReportDialog .tournamentReportFormModern__dateRange .sit-dp {
  width: 100%;
}

.tnReportDialog .tournamentReportFormModern__options {
  overflow: hidden;
  border: 1px solid #e4eaf1;
  border-radius: 12px;
  background: #fff;
}

.tnReportDialog .tournamentReportFormModern__option {
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 10px 13px;
  border-bottom: 1px solid #edf1f5;
}

.tnReportDialog .tournamentReportFormModern__option:last-child {
  border-bottom: 0;
}

.tnReportDialog .tournamentReportFormModern__option > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
  text-align: left;
}

.tnReportDialog .tournamentReportFormModern__option strong {
  color: #27364b;
  font-size: 13.5px;
  font-weight: 650;
}

.tnReportDialog .tournamentReportFormModern__option small {
  color: #667085;
  font-size: 11.5px;
  line-height: 1.35;
}

.tnReportDialog .form-group .d-flex,
.tnReportDialog .form-check .d-flex {
  align-items: center;
}

.tnReportDialog .form-group > .d-flex,
.tnReportDialog .form-check > .d-flex {
  min-height: 38px;
  flex-direction: row-reverse;
  justify-content: space-between;
  gap: 16px;
}

.tnReportDialog .form-group > .d-flex > .d-flex,
.tnReportDialog .form-check > .d-flex > .d-flex {
  min-width: 0;
  flex: 1 1 auto;
  align-items: flex-start;
  justify-content: flex-start !important;
  flex-direction: column;
  gap: 2px;
  text-align: left;
}

.tnReportDialog .form-check-label {
  width: 100%;
  flex: none;
  margin: 0;
  padding-left: 0 !important;
  color: #344054;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.35;
  text-align: left;
}

.tnReportDialog .eFieldInlineHint {
  display: block;
  width: 100%;
  margin: 0;
  color: #667085;
  font-size: 11.5px;
  font-weight: 400;
  line-height: 1.4;
  text-align: left;
}

.tnReportDialog .sit-switch {
  flex: 0 0 auto;
  margin: 0;
}

.tnReportDialog .sit-switch__track {
  width: 38px;
  height: 22px;
  border: 1px solid #b8c4d3;
  border-radius: 999px;
  background: #cbd5e1;
  box-sizing: border-box;
}

.tnReportDialog .sit-switch__thumb {
  width: 18px;
  height: 18px;
  border: 1px solid rgba(23, 32, 51, 0.12);
  border-radius: 50%;
  background: #fff;
  box-sizing: border-box;
  box-shadow: 0 1px 3px rgba(23, 32, 51, 0.24);
}

.tnReportDialog .sit-switch input:checked + .sit-switch__track {
  border-color: #2463a7;
  background: #2463a7;
}

.tnReportDialog .sit-switch input:focus-visible + .sit-switch__track {
  box-shadow: 0 0 0 3px rgba(36, 99, 167, 0.2);
}

.tnReportDialog .tournamentReportFormModern__footer {
  position: sticky;
  bottom: -22px;
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  margin: 18px -24px -22px;
  padding: 14px 24px;
  border-top: 1px solid #e7edf4;
  background: #fbfdff;
}

.tnReportDialog .tournamentReportFormModern__footer .btn {
  border: 0;
  border-radius: 9px;
  padding: 9px 17px;
  font-size: 14px;
  font-weight: 650;
}

.tnReportDialog .tournamentReportFormModern__footer .btn-secondary {
  border: 1px solid #d7dee8;
  background: #fff;
  color: #344054;
}

.tnReportDialog .tournamentReportFormModern__footer .btn-primary {
  background: #2463a7;
  color: #fff;
}

.tnReportPicker__footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/Tournaments/TournamentsHub/TournamentsHub.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,gCAAgC;EAChC,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,sDAAsD;EACtD,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,eAAe;AACjB;AACA;;EAEE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,uCAAuC;AACzC;AACA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+CAA+C;EAC/C,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,sDAAsD;EACtD,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,0CAA0C;AAC5C;AACA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;AACA;;;EAGE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,YAAY;EACZ,WAAW;EACX,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,0CAA0C;EAC1C,gDAAgD;EAChD,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;EACjD,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;AACA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,4CAA4C;AAC9C;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,kBAAkB;EAClB,sDAAsD;EACtD,oCAAoC;EACpC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,iCAAiC;AACnC;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,4EAA4E;AAC9E;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,kCAAkC;EAClC,mCAAmC;AACrC;AACA;EACE,QAAQ;EACR,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,kCAAkC;AACpC;AACA;;EAEE,cAAc;AAChB;AACA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,SAAS;EACT,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,aAAa;EACb,wBAAwB;EACxB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,8CAA8C;EAC9C,gCAAgC;EAChC,mEAAmE;AACrE;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,sDAAsD;EACtD,0DAA0D;AAC5D;AACA;EACE,SAAS;EACT,mCAAmC;EACnC,8FAA8F;EAC9F,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,kBAAkB;EAClB,sDAAsD;EACtD,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;AACA;;EAEE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,sDAAsD;AACxD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,mDAAmD;EACnD,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,mCAAmC;EACnC,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,mCAAmC;EACnC,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mCAAmC;AACrC;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;;;;IAIE,WAAW;EACb;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;AACA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,qCAAqC;EACrC,qCAAqC;EACrC,8CAA8C;EAC9C,gCAAgC;EAChC,mEAAmE;AACrE;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sDAAsD;EACtD,0DAA0D;AAC5D;AACA;EACE,SAAS;EACT,mCAAmC;EACnC,8FAA8F;EAC9F,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mCAAmC;EACnC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,mDAAmD;EACnD,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,mCAAmC;EACnC,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mCAAmC;AACrC;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;;;IAGE,eAAe;IACf,sDAAsD;EACxD;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,WAAW;EACb;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,8BAA8B;EAChC;AACF;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;;EAEE,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE;;;IAGE,oBAAoB;IACpB,sBAAsB;EACxB;EACA;;;;;IAKE,WAAW;EACb;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;AACjB;AACA;;EAEE,0CAA0C;EAC1C,gDAAgD;EAChD,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,8MAA8M;EAC9M,sNAAsN;AACxN;AACA;EACE,gRAAgR;EAChR,wRAAwR;AAC1R;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE;IACE,oBAAoB;IACpB,sBAAsB;EACxB;EACA;;;;IAIE,WAAW;EACb;AACF;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,kBAAkB;AACpB;AACA;;;EAGE,YAAY;AACd;AACA;EACE;IACE,oBAAoB;EACtB;EACA;;IAEE,gBAAgB;EAClB;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,WAAW;EACX,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,4CAA4C;EAC5C,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,4EAA4E;AAC5E;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,MAAM;EACN,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,oDAAoD;EACpD,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,sDAAsD;AACxD;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE;IACE,MAAM;IACN,OAAO;IACP,YAAY;IACZ,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE;;IAEE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA,0FAA0F;AAC1F;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,wCAAwC;EACxC,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,sDAAsD;EACtD,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;;EAEE,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;EACrC,8DAA8D;AAChE;;AAEA;EACE,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yEAAyE;EACzE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,0CAA0C;EAC1C,4CAA4C;EAC5C,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,sCAAsC;EACtC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,sDAAsD;AACxD;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,wFAAwF;AAC1F;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yCAAyC,eAAe,EAAE;EAC1D,wCAAwC,eAAe,EAAE;AAC3D;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;;IAGE,sBAAsB;EACxB;;EAEA;;;;IAIE,WAAW;EACb;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,4BAA4B;EAC5B,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uPAAuP;AACzP;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,sCAAsC;EACtC,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,SAAS;EACT,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,wBAAwB;EACxB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[".tnPage {\n  min-height: calc(100vh - 64px);\n  background: var(--surface-page, #f6f8fb);\n  color: var(--text-body, #172033);\n  font-family: var(--font-body, inherit);\n}\n.tnTopbar {\n  height: 62px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 0 24px;\n  border-bottom: 1px solid var(--border-subtle, #dbe4ef);\n  background: var(--surface-card, #fff);\n}\n.tnBreadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-muted, #64748b);\n  font-size: 14px;\n}\n.tnBreadcrumb i,\n.tnDrawerHead i {\n  width: 4px;\n  height: 4px;\n  border-radius: 999px;\n  background: var(--text-subtle, #94a3b8);\n}\n.tnBreadcrumb b {\n  color: var(--text-strong, #172033);\n  font-weight: 650;\n}\n.tnPending {\n  position: relative;\n  margin-left: auto;\n  width: 38px;\n  height: 38px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--border-subtle, #dbe4ef);\n  border-radius: 9px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n}\n.tnPending span {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  min-width: 18px;\n  height: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: #e5484d;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n}\n.tnMain {\n  max-width: 1180px;\n  padding: 24px 28px 48px;\n}\n.tnTitleBlock {\n  margin-bottom: 18px;\n}\n.tnTitleBlock h1 {\n  margin: 0;\n  color: var(--text-strong, #172033);\n  font-size: 24px;\n  line-height: 30px;\n  font-weight: 800;\n  letter-spacing: 0;\n}\n.tnTitleBlock p,\n.tnToolbar p {\n  margin: 3px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 14px;\n  line-height: 20px;\n}\n.tnTabs {\n  display: flex;\n  align-items: flex-end;\n  gap: 22px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  border-bottom: 1px solid var(--border-subtle, #dbe4ef);\n  margin-bottom: 16px;\n}\n.tnTabs::-webkit-scrollbar {\n  display: none;\n  width: 0;\n  height: 0;\n}\n.tnTabs button {\n  position: relative;\n  min-height: 42px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: 0;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-size: 14px;\n  font-weight: 650;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.tnTabs button.isActive {\n  color: var(--text-strong, #172033);\n}\n.tnTabs button.isActive::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -1px;\n  height: 2px;\n  border-radius: 999px;\n  background: var(--action-primary, #227ebd);\n}\n.tnTabs span,\n.tnArchiveSegment span,\n.tnColumnsBtn span {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: var(--slate-200, #e2e8f0);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 750;\n}\n.tnToolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px 16px;\n  margin-bottom: 16px;\n}\n.tnToolbarMain {\n  flex: 1 1 220px;\n}\n.tnToolbarMain h2 {\n  margin: 0;\n  color: var(--text-strong, #172033);\n  font-size: 18px;\n  line-height: 24px;\n  font-weight: 750;\n}\n.tnToolbarMain span {\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n}\n.tnToolbarActions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n.tnSearch,\n.tnToolbar select,\n.tnColumnsBtn {\n  height: 38px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid var(--border-default, #d7e0ea);\n  border-radius: 9px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #172033);\n  font-size: 13px;\n}\n.tnSearch {\n  width: 230px;\n  padding: 0 11px;\n  color: var(--text-muted, #64748b);\n}\n.tnSearch input {\n  min-width: 0;\n  width: 100%;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: var(--text-body, #172033);\n  font-size: 14px;\n}\n.tnToolbar select {\n  min-width: 140px;\n  padding: 0 28px 0 10px;\n}\n.tnColumns {\n  position: relative;\n}\n.tnColumnsBtn {\n  padding: 0 12px;\n  cursor: pointer;\n  font-weight: 650;\n}\n.tnColumnsBtn.isOpen,\n.tnColumnsBtn:hover {\n  border-color: var(--border-brand, #227ebd);\n  background: var(--surface-brand-subtle, #eef6fc);\n  color: #227ebd;\n}\n.tnColumnsMenu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  z-index: 30;\n  width: 244px;\n  padding: 8px;\n  border: 1px solid var(--border-subtle, #dbe4ef);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.16);\n}\n.tnColumnsMenuHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 6px 8px 8px;\n}\n.tnColumnsMenuHead strong {\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n.tnColumnsMenuHead button {\n  border: 0;\n  background: transparent;\n  color: #227ebd;\n  font-size: 12px;\n  font-weight: 650;\n  cursor: pointer;\n}\n.tnColumnOption {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--text-body, #172033);\n  font-size: 13px;\n  text-align: left;\n  cursor: pointer;\n}\n.tnColumnOption:hover {\n  background: var(--surface-hover, #f8fafc);\n}\n.tnColumnOption.isLocked {\n  color: var(--text-subtle, #94a3b8);\n  cursor: default;\n}\n.tnColumnOption em {\n  margin-left: auto;\n  font-size: 11px;\n  font-style: normal;\n}\n.tnColumnCheck {\n  width: 17px;\n  height: 17px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1.5px solid var(--border-strong, #cbd5e1);\n  border-radius: 4px;\n  color: #fff;\n  font-size: 12px;\n  line-height: 1;\n}\n.tnColumnCheck.isChecked {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n}\n.tnArchiveSegment {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px;\n  margin-bottom: 16px;\n  border-radius: 10px;\n  background: var(--slate-100, #f1f5f9);\n}\n.tnArchiveSegment button {\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 0 13px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  font-weight: 650;\n  cursor: pointer;\n}\n.tnArchiveSegment button.isActive {\n  background: var(--surface-card, #fff);\n  color: var(--text-strong, #172033);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.14);\n}\n.tnArchiveSegment button.isActive span {\n  background: #227ebd;\n  color: #fff;\n}\n.tnSelection {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding: 10px 12px;\n  border: 1px solid #cfe0ff;\n  border-radius: 10px;\n  background: #f4f8ff;\n}\n.tnSelection div {\n  display: flex;\n  gap: 8px;\n}\n.tnBtn {\n  min-height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  border-radius: 9px;\n  padding: 7px 12px;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 18px;\n  cursor: pointer;\n}\n.tnBtnPrimary {\n  border: 1px solid #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n.tnBtnSecondary {\n  border: 1px solid var(--border-default, #d7e0ea);\n  background: #fff;\n  color: #172033;\n}\n.tnBtnGhost {\n  border: 1px solid transparent;\n  background: transparent;\n  color: #475569;\n}\n.tnTableCard {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #dbe4ef);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n.tnTableScroll {\n  width: 100%;\n  overflow-x: auto;\n}\n.tnTable {\n  width: 100%;\n  min-width: 940px;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n.tnTable th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  padding: 10px 16px;\n  border-bottom: 1px solid var(--border-subtle, #dbe4ef);\n  background: var(--slate-50, #f8fafc);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-align: left;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n.tnTable th.isSortable {\n  cursor: pointer;\n}\n.tnTable th > span {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n}\n.tnTable td {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-subtle, #edf2f7);\n  color: var(--text-body, #172033);\n  font-size: 13px;\n  vertical-align: middle;\n}\n.tnTable tbody tr {\n  cursor: pointer;\n  transition: background 0.12s ease;\n}\n.tnTable tbody tr:hover,\n.tnTable tbody tr.isPreview {\n  background: #eef6fc;\n}\n.tnTable tbody tr:last-child td {\n  border-bottom: 0;\n}\n.tnCheck {\n  width: 1%;\n  padding-right: 0 !important;\n  text-align: center !important;\n}\n.tnCheck input {\n  width: 17px;\n  height: 17px;\n  accent-color: #227ebd;\n}\n.tnName strong {\n  display: block;\n  color: var(--text-strong, #172033);\n  font-size: 13.5px;\n  font-weight: 650;\n}\n\n.tnName__title {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 7px;\n}\n\n.tnPublicSiteIcon {\n  display: inline-flex;\n  width: 26px;\n  height: 26px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #cbd9e5;\n  border-radius: 7px;\n  background: #f7fbfd;\n  color: #1a6da3;\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;\n}\n\n.tnPublicSiteIcon:hover,\n.tnPublicSiteIcon:focus-visible {\n  border-color: #1a6da3;\n  background: #eaf6fb;\n  color: #124f76;\n  text-decoration: none;\n}\n.tnName small {\n  display: block;\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n}\n.tnName__meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 4px;\n  color: #667085;\n  font-size: 11.5px;\n}\n.tnName__meta i {\n  width: 9px;\n  height: 9px;\n  flex: 0 0 9px;\n  border-radius: 2px;\n}\n.tnName__meta b {\n  color: #c3cad5;\n  font-weight: 400;\n}\n.tnQueue,\n.tnStatus,\n.tnKindPill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 22px;\n  border-radius: 999px;\n  padding: 3px 8px;\n  background: var(--slate-100, #f1f5f9);\n  color: #334155;\n  font-size: 11.5px;\n  font-style: normal;\n  font-weight: 650;\n  text-align: center;\n}\n.tnDate,\n.tnVenue {\n  white-space: nowrap;\n}\n.tnDeadline {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 96px;\n}\n.tnDeadline strong {\n  color: #172033;\n  font-size: 13px;\n  font-weight: 650;\n  white-space: nowrap;\n}\n.tnDeadline small {\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 650;\n  white-space: nowrap;\n}\n.tnDeadline.isSoon small {\n  color: #b42318;\n}\n.tnKindPill--invite {\n  background: #ecfeff;\n  color: #0e7490;\n}\n.tnKindPill--request {\n  background: #f0fdf4;\n  color: #15803d;\n}\n.tnKindPill--tournament {\n  background: #eef4ff;\n  color: #1d4ed8;\n}\n.tnStatus--success {\n  background: #ecfdf3;\n  color: #067647;\n}\n.tnStatus--info {\n  background: #eef4ff;\n  color: #1d4ed8;\n}\n.tnStatus--warning {\n  background: #fff7ed;\n  color: #c2410c;\n}\n.tnStatus--danger {\n  background: #fef3f2;\n  color: #b42318;\n}\n.tnStatus--neutral {\n  background: #f1f5f9;\n  color: #475569;\n}\n.tnEmpty {\n  height: 132px;\n  color: #64748b !important;\n  text-align: center;\n}\n.tnSort {\n  display: inline-flex;\n  width: 8px;\n  height: 12px;\n  position: relative;\n  color: #cbd5e1;\n}\n.tnSort::before,\n.tnSort::after {\n  content: '';\n  position: absolute;\n  left: 1px;\n  border-left: 3px solid transparent;\n  border-right: 3px solid transparent;\n}\n.tnSort::before {\n  top: 1px;\n  border-bottom: 4px solid currentColor;\n}\n.tnSort::after {\n  bottom: 1px;\n  border-top: 4px solid currentColor;\n}\n.tnSort.isasc::before,\n.tnSort.isdesc::after {\n  color: #227ebd;\n}\n.tnDrawerBackdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1040;\n  border: 0;\n  background: rgba(15, 23, 42, 0.28);\n  backdrop-filter: blur(2px);\n  cursor: default;\n}\n.tnDrawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 1041;\n  width: min(460px, 100vw);\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--surface-card, #fff);\n  box-shadow: -18px 0 42px rgba(15, 23, 42, 0.2);\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n.tnDrawerHead {\n  display: grid;\n  grid-template-columns: 44px minmax(0, 1fr) 34px;\n  gap: 12px;\n  align-items: start;\n  padding: 20px 22px;\n  border-bottom: 1px solid var(--border-subtle, #dbe4ef);\n  background: linear-gradient(180deg, #fff 0%, #fbfdff 100%);\n}\n.tnDrawerHead h2 {\n  margin: 0;\n  color: var(--text-heading, #0f172a);\n  font-family: var(--font-heading, var(--font-display, 'Hanken Grotesk', system-ui, sans-serif));\n  font-size: 20px;\n  line-height: 26px;\n  font-weight: 850;\n}\n.tnDrawerHead p {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 5px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n}\n.tnDrawerHead button {\n  width: 34px;\n  height: 34px;\n  border: 1px solid var(--border-default, #d7e0ea);\n  border-radius: 9px;\n  background: #fff;\n  color: #475569;\n  font-size: 21px;\n  line-height: 28px;\n  cursor: pointer;\n}\n.tnDrawerHead button:hover {\n  background: var(--surface-subtle, #f8fafc);\n  color: var(--text-heading, #0f172a);\n}\n.tnDrawerIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n}\n.tnKind--waiting {\n  background: #fff7ed;\n  color: #c2410c;\n}\n.tnKind--invite {\n  background: #ecfeff;\n  color: #0e7490;\n}\n.tnKind--request {\n  background: #f0fdf4;\n  color: #15803d;\n}\n.tnKind--tournament {\n  background: #eef4ff;\n  color: #0f5fff;\n}\n.tnDrawerBody {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: 20px 22px;\n  background: var(--surface-subtle, #f8fafc);\n}\n.tnDrawerTabs {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 6px;\n  padding: 10px 22px;\n  border-bottom: 1px solid var(--border-subtle, #dbe4ef);\n  background: #fff;\n}\n.tnDrawerTabs button {\n  min-height: 38px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 7px 10px;\n  border: 1px solid transparent;\n  border-radius: 9px;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n  font-weight: 750;\n  cursor: pointer;\n}\n.tnDrawerTabs button:hover {\n  background: #f5f8fb;\n  color: var(--text-heading, #0f172a);\n}\n.tnDrawerTabs button.isActive {\n  border-color: #cfe3f2;\n  background: #eef6fc;\n  color: #155d8c;\n}\n.tnDrawerTabs button span {\n  min-width: 20px;\n  height: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 6px;\n  border-radius: 999px;\n  background: #227ebd;\n  color: #fff;\n  font-size: 10px;\n}\n.tnDrawerBody--updates {\n  padding: 0;\n}\n.tnDrawerBody--updates .bTournamentAdditionalInfo {\n  padding: 16px;\n}\n.tnDrawerBody--updates .eAdditionalInfoSection {\n  border-color: #dbe4ef;\n  background: #f8fafc;\n}\n.tnDrawerBody--updates .eAdditionalInfoSectionHeader {\n  padding: 16px;\n}\n.tnDrawerBody--updates .eAdditionalInfoList {\n  padding: 12px;\n}\n.tnDrawerBody--updates .bAnnounce {\n  padding: 16px;\n  border-radius: 12px;\n}\n.tnDrawerBody--updates .eAnnounceMain {\n  gap: 14px;\n}\n.tnDrawerBody--updates .eAnnounceMain--withMedia {\n  grid-template-columns: 92px minmax(0, 1fr);\n}\n.tnDrawerBody--updates .eAnnounceImageThumbButton {\n  width: 92px;\n  height: 92px;\n  border-radius: 10px;\n}\n.tnDrawerBody--updates .eAnnounceTitle {\n  font-size: 17px;\n}\n.tnDrawerBody--updates .eAnnounceAttachmentCard {\n  align-items: flex-start;\n  flex-direction: column;\n}\n.tnDrawerNotice,\n.tnDrawerContext {\n  display: flex;\n  gap: 10px;\n  padding: 12px 14px;\n  margin-bottom: 12px;\n  border-radius: 9px;\n  border: 1px solid #cfe0ff;\n  background: #f4f8ff;\n  color: #1d4ed8;\n  font-size: 13px;\n  line-height: 18px;\n}\n.tnDrawerNotice.isSoon {\n  border-color: #fed7aa;\n  background: #fff7ed;\n  color: #c2410c;\n}\n.tnDrawerContext {\n  display: block;\n  color: #1c4e73;\n  background: #eef5fb;\n  border-color: #cfe1f2;\n}\n.tnDrawerContext.isWaiting {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 11px;\n  padding: 14px;\n  border-color: #f1d49a;\n  background: #fffaf0;\n  color: #71551e;\n}\n.tnDrawerContext.isWaiting > span {\n  width: 24px;\n  height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: #f4b740;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 900;\n}\n.tnDrawerContext.isWaiting strong {\n  display: block;\n  margin: 1px 0 4px;\n  color: #7a4b08;\n  font-size: 13px;\n  font-weight: 800;\n}\n.tnDrawerContext.isWaiting p {\n  margin: 0;\n  color: #71551e;\n  font-size: 12.5px;\n  line-height: 1.5;\n}\n.tnDrawerContext.isParticipant {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 11px;\n  padding: 14px;\n  border-color: #bfe4cd;\n  background: #f1fbf5;\n  color: #17653a;\n}\n.tnDrawerContext.isParticipant > span {\n  width: 26px;\n  height: 26px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: #21874d;\n  color: #fff;\n}\n.tnDrawerContext.isParticipant strong {\n  display: block;\n  margin: 1px 0 4px;\n  color: #155f37;\n  font-size: 13px;\n  font-weight: 800;\n}\n.tnDrawerContext.isParticipant p {\n  margin: 0;\n  color: #277149;\n  font-size: 12.5px;\n  line-height: 1.5;\n}\n.tnDrawerSectionTitle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 18px 0 9px;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n.tnDrawerSectionTitle::after {\n  content: '';\n  flex: 1 1 auto;\n  height: 1px;\n  background: var(--border-subtle, #e2e8f0);\n}\n.tnDrawerDetails {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #fff);\n}\n.tnDrawerField {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 0;\n  padding: 13px 14px;\n  border-bottom: 1px solid var(--border-subtle, #edf2f7);\n}\n.tnDrawerField:nth-child(odd) {\n  border-right: 1px solid var(--border-subtle, #edf2f7);\n}\n.tnDrawerField:nth-last-child(-n + 2) {\n  border-bottom: 0;\n}\n.tnDrawerField > span {\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n.tnDrawerField strong {\n  color: var(--text-strong, #172033);\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 650;\n  overflow-wrap: anywhere;\n}\n\n.tnPublicSiteLink {\n  display: flex;\n  min-height: 58px;\n  align-items: center;\n  gap: 11px;\n  margin-top: 12px;\n  padding: 10px 12px;\n  border: 1px solid #cfe3f2;\n  border-radius: 11px;\n  background: #f4f9fd;\n  color: var(--text-body, #334155);\n  text-decoration: none;\n}\n\n.tnPublicSiteLink:hover,\n.tnPublicSiteLink:focus-visible {\n  border-color: #8dbbd9;\n  background: #eef6fc;\n  color: var(--text-body, #334155);\n  outline: none;\n  text-decoration: none;\n}\n\n.tnPublicSiteLink__icon {\n  display: inline-flex;\n  width: 34px;\n  height: 34px;\n  flex: 0 0 34px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9px;\n  background: #ddecf7;\n  color: var(--blue-700, #155d8c);\n}\n\n.tnPublicSiteLink > span:nth-child(2) {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.tnPublicSiteLink small,\n.tnPublicSiteLink strong {\n  display: block;\n}\n\n.tnPublicSiteLink small {\n  margin-bottom: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 10.5px;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.tnPublicSiteLink strong {\n  overflow: hidden;\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n  font-weight: 700;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.tnPublicSiteLink > b {\n  display: inline-flex;\n  min-height: 32px;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 6px;\n  padding: 0 10px;\n  border-radius: 8px;\n  background: var(--blue-600, #227ebd);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 750;\n}\n.tnDrawerFoot {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 16px 22px;\n  border-top: 1px solid var(--border-subtle, #dbe4ef);\n  background: #fbfdff;\n}\n.tnDrawerActions {\n  width: 100%;\n}\n.tnDrawerActions__main {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 9px;\n}\n.tnDrawerActions__main.hasTeamManagement > .tnBtnPrimary {\n  grid-column: 1 / -1;\n}\n.tnDrawerActions__main .tnBtn {\n  min-height: 42px;\n}\n.tnInviteActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  width: 100%;\n}\n.tnInviteActions button {\n  min-height: 40px;\n  padding: 0 15px;\n  border: 1px solid #227ebd;\n  border-radius: 8px;\n  background: #227ebd;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n}\n.tnInviteActions button:hover {\n  background: #176da8;\n}\n.tnInviteActions button.is-danger {\n  border-color: transparent;\n  background: var(--red-500, #da4453);\n}\n.tnInviteActions button.is-danger:hover {\n  background: var(--red-600, #c4313f);\n}\n.tnDrawerActions__help {\n  display: flex;\n  align-items: flex-start;\n  gap: 7px;\n  margin: 9px 2px 0;\n  color: #64748b;\n  font-size: 12px;\n  line-height: 17px;\n}\n.tnDrawerActions__help svg {\n  flex: 0 0 auto;\n  margin-top: 1px;\n}\n.tnDrawerActions__help.isempty {\n  color: #775b20;\n}\n.tnDrawerActions__help.iserror {\n  color: #a43a43;\n}\n.tnDrawer .tnDrawerActions__withdraw {\n  width: 100%;\n  min-height: 40px;\n  margin-top: 14px;\n  border-color: var(--red-500, #c4313f);\n  background: var(--red-500, #c4313f);\n  color: #fff;\n  font-weight: 750;\n}\n.tnDrawer .tnDrawerActions__withdraw:hover:not(:disabled) {\n  border-color: var(--red-600, #a92734);\n  background: var(--red-600, #a92734);\n  color: #fff;\n}\n.tnBtnWithIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n}\n.tnDrawer.isWaiting .tnDrawerFoot .tnBtnDanger {\n  min-height: 40px;\n  padding: 0 15px;\n  border-color: var(--red-500, #c4313f);\n  background: var(--red-500, #c4313f);\n  color: #fff;\n  font-weight: 750;\n}\n.tnDrawer.isWaiting .tnDrawerFoot .tnBtnDanger:hover:not(:disabled) {\n  background: var(--red-600, #a92734);\n}\n@media (max-width: 760px) {\n  .tnTopbar {\n    padding: 0 14px;\n  }\n  .tnMain {\n    padding: 18px 14px 32px;\n  }\n  .tnToolbarActions,\n  .tnSearch,\n  .tnToolbar select,\n  .tnColumns {\n    width: 100%;\n  }\n  .tnColumnsBtn {\n    width: 100%;\n    justify-content: center;\n  }\n  .tnArchiveSegment {\n    width: 100%;\n    overflow-x: auto;\n  }\n}\n.tnBtnDanger {\n  border-color: #fecaca;\n  background: #fff;\n  color: #b42318;\n}\n.tnBtnDanger:hover:not(:disabled) {\n  background: #fef3f2;\n}\n.tnBtn:disabled {\n  cursor: not-allowed;\n  border-color: #e2e8f0;\n  background: #f1f5f9;\n  color: #94a3b8;\n  opacity: 1;\n}\n.tnModalBackdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 18px;\n  background: rgba(15, 23, 42, 0.38);\n  backdrop-filter: blur(3px);\n}\n\n.tnModalBackdrop--aboveModal {\n  z-index: 1060;\n}\n.tnModal {\n  width: min(520px, 100%);\n  overflow: hidden;\n  border: 0;\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #fff);\n  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.24);\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n.tnModalHead {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 13px;\n  padding: 20px 22px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: linear-gradient(180deg, #fff 0%, #fbfdff 100%);\n}\n.tnModalHead h3 {\n  margin: 0;\n  color: var(--text-heading, #0f172a);\n  font-family: var(--font-heading, var(--font-display, 'Hanken Grotesk', system-ui, sans-serif));\n  font-size: 19px;\n  line-height: 24px;\n  font-weight: 850;\n}\n.tnModalHead p {\n  margin: 3px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n  font-weight: 550;\n  line-height: 1.4;\n}\n.tnModalIcon {\n  width: 40px;\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-md, 8px);\n  background: #fff1f2;\n  color: var(--red-600, #c4313f);\n}\n.tnModal.isSuccess .tnModalIcon {\n  border-radius: 50%;\n  background: #e8f7ee;\n  color: #21874d;\n}\n.tnModal.isWarning .tnModalIcon {\n  background: #fff8e8;\n  color: #b7791f;\n}\n.tnModalHead button {\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--border-default, #d7e0ea);\n  border-radius: 8px;\n  background: #fff;\n  color: #475569;\n  font-size: 20px;\n  line-height: 26px;\n  cursor: pointer;\n}\n.tnModalHead button:hover:not(:disabled) {\n  background: var(--surface-subtle, #f8fafc);\n  color: var(--text-heading, #0f172a);\n}\n.tnModalBody {\n  padding: 22px;\n  color: var(--text-default, #334155);\n  font-size: 14px;\n  line-height: 21px;\n}\n.tnModalMessage {\n  padding: 14px 15px;\n  border: 1px solid #ffd5da;\n  border-radius: var(--radius-md, 8px);\n  background: #fff5f6;\n  color: #9f2430;\n  font-size: 13px;\n  font-weight: 650;\n  line-height: 1.5;\n}\n.tnModal.isSuccess .tnModalMessage {\n  border-color: #bfe4cd;\n  background: #f1fbf5;\n  color: #17653a;\n}\n.tnModal.isWarning .tnModalMessage {\n  border-color: #f1d49a;\n  background: #fffaf0;\n  color: #71551e;\n}\n.tnModalError {\n  margin-top: 12px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #fecaca;\n  background: #fef3f2;\n  color: #b42318;\n  font-size: 13px;\n}\n.tnModalFoot {\n  display: flex;\n  justify-content: flex-end;\n  gap: 9px;\n  padding: 16px 22px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  background: #fbfdff;\n}\n.tnModal.isDanger .tnModalFoot .tnBtnDanger {\n  min-height: 40px;\n  padding: 0 15px;\n  border-color: var(--red-500, #c4313f);\n  background: var(--red-500, #c4313f);\n  color: #fff;\n  font-weight: 750;\n}\n.tnModal.isDanger .tnModalFoot .tnBtnDanger:hover:not(:disabled) {\n  background: var(--red-600, #a92734);\n}\n@media (max-width: 560px) {\n  .tnDrawerDetails {\n    grid-template-columns: 1fr;\n  }\n  .tnDrawerField,\n  .tnDrawerField:nth-child(odd),\n  .tnDrawerField:nth-last-child(-n + 2) {\n    border-right: 0;\n    border-bottom: 1px solid var(--border-subtle, #edf2f7);\n  }\n  .tnDrawerField:last-child {\n    border-bottom: 0;\n  }\n  .tnDrawerFoot .tnBtn,\n  .tnModalFoot .tnBtn {\n    width: 100%;\n  }\n  .tnDrawerActions__main {\n    grid-template-columns: 1fr;\n  }\n  .tnModalFoot {\n    flex-direction: column-reverse;\n  }\n}\n.tnToolbar {\n  display: block;\n  margin-bottom: 16px;\n}\n.tnToolbarHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 6px;\n}\n.tnFilterPanel {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 10px;\n  margin-top: 12px;\n  padding: 12px;\n  border: 1px solid var(--border-subtle, #dbe4ef);\n  border-radius: 10px;\n  background: var(--surface-card, #fff);\n}\n.tnFilterPanel label {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  min-width: 150px;\n}\n.tnFilterPanel label > span {\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n.tnFilterPanel select,\n.tnFilterPanel input[type='date'] {\n  height: 38px;\n  border: 1px solid var(--border-default, #d7e0ea);\n  border-radius: 9px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #172033);\n  font-size: 13px;\n}\n.tnFilterPanel select {\n  min-width: 150px;\n  padding: 0 28px 0 10px;\n}\n.tnFilterPanel input[type='date'] {\n  min-width: 155px;\n  padding: 0 10px;\n}\n.tnFilterColumns {\n  position: relative;\n}\n.tnFilterReset {\n  min-height: 38px;\n}\n.tnPagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 12px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n}\n.tnPagination > div {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.tnPageBtn {\n  min-width: 34px;\n  height: 34px;\n  padding: 0 10px;\n  border: 1px solid var(--border-default, #d7e0ea);\n  border-radius: 8px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #172033);\n  font-size: 13px;\n  font-weight: 650;\n  cursor: pointer;\n}\n.tnPageBtn.isActive {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n.tnPageBtn:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n.tnPageGap {\n  padding: 0 2px;\n  color: var(--text-muted, #64748b);\n}\n.tnPageSummary {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.tnPageSummary label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n}\n.tnPageSummary select {\n  height: 32px;\n  border: 1px solid var(--border-default, #d7e0ea);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text-body, #172033);\n}\n@media (max-width: 760px) {\n  .tnToolbarHead,\n  .tnPagination,\n  .tnPageSummary {\n    align-items: stretch;\n    flex-direction: column;\n  }\n  .tnFilterPanel label,\n  .tnFilterPanel select,\n  .tnFilterPanel input[type='date'],\n  .tnFilterColumns,\n  .tnFilterReset {\n    width: 100%;\n  }\n  .tnPagination > div {\n    flex-wrap: wrap;\n  }\n}\n.tnToolbar {\n  display: block;\n  margin-bottom: 16px;\n}\n.tnToolbarHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 6px;\n}\n.tnToolbarControls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.tnSectionTitleRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.tnResponseBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  min-height: 24px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: #fef3f2;\n  color: #b42318;\n  font-size: 12px;\n  font-weight: 800;\n}\n.tnIconBtn {\n  position: relative;\n  width: 38px;\n  height: 38px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--border-default, #d7e0ea);\n  border-radius: 9px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  cursor: pointer;\n}\n.tnIconBtn:hover,\n.tnIconBtn.isOn {\n  border-color: var(--border-brand, #227ebd);\n  background: var(--surface-brand-subtle, #eef6fc);\n  color: #227ebd;\n}\n.tnIconBtnDot {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  width: 7px;\n  height: 7px;\n  border: 1.5px solid #fff;\n  border-radius: 50%;\n  background: #f08c1a;\n}\n.tnMaskedIcon {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  display: inline-block;\n  background: currentColor;\n  mask-position: center;\n  mask-repeat: no-repeat;\n  mask-size: 16px 16px;\n  -webkit-mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-size: 16px 16px;\n}\n.tnMaskedIcon--filter {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E\");\n}\n.tnMaskedIcon--columns {\n  mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E\");\n  -webkit-mask-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E\");\n}\n.tnColumnsBtn {\n  height: 38px;\n}\n.tnFilterPanel {\n  margin-top: 12px;\n}\n.tnToolbarMain {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n.tnSectionTitleRow {\n  flex-wrap: wrap;\n}\n.tnSectionTitleRow .tnSearch {\n  margin-left: 2px;\n  margin-bottom: 0;\n}\n@media (max-width: 760px) {\n  .tnSectionTitleRow {\n    align-items: stretch;\n    flex-direction: column;\n  }\n  .tnSectionTitleRow .tnSearch,\n  .tnSectionTitleRow .tnColumns,\n  .tnSectionTitleRow .tnColumnsBtn,\n  .tnSectionTitleRow .tnIconBtn {\n    width: 100%;\n  }\n}\n.tnSectionTitleRow {\n  align-items: flex-end;\n}\n.tnSectionTitleRow h2,\n.tnResponseBadge {\n  margin-bottom: 1px;\n}\n.tnSectionTitleRow .tnIconBtn,\n.tnSectionTitleRow .tnColumnsBtn,\n.tnSectionTitleRow .tnSearch {\n  height: 40px;\n}\n@media (max-width: 760px) {\n  .tnSectionTitleRow {\n    align-items: stretch;\n  }\n  .tnSectionTitleRow h2,\n  .tnResponseBadge {\n    margin-bottom: 0;\n  }\n}\n.tnDateRangePicker {\n  min-width: 260px;\n}\n.tnFilterPanel .tnDateRangePicker .sit-dp__label {\n  display: block;\n  width: 100%;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  text-align: left;\n}\n.tnFilterPanel .tnDateRangePicker .sit-dp__trigger {\n  height: 38px;\n  border-color: var(--border-default, #d7e0ea);\n  border-radius: 9px;\n  font-size: 13px;\n}\n@media (max-width: 760px) {\n  .tnDateRangePicker {\n    width: 100%;\n    min-width: 0;\n  }\n}\n\n/* List filters handoff: tournament lists use the large right-side drawer. */\n.tnSectionTitleRow .tnIconBtn {\n  width: auto;\n  min-width: 92px;\n  gap: 7px;\n  padding: 0 12px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.tnSectionTitleRow .tnIconBtn b {\n  display: inline-flex;\n  min-width: 18px;\n  height: 18px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: #227ebd;\n  color: #fff;\n  font-size: 10px;\n}\n\n.tnFilterPanel {\n  position: fixed;\n  z-index: 1060;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: auto;\n  display: flex;\n  width: 360px;\n  max-width: calc(100vw - 20px);\n  height: auto;\n  max-height: none;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  gap: 0;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  border: 0;\n  border-left: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 0;\n  background: #fff;\n  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);\n}\n\n.tnFilterPanel > header {\n  display: flex;\n  min-height: 34px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  margin: 18px 18px 0;\n  padding: 0 0 12px !important;\n  border-bottom: 1px solid var(--border-subtle, #e7edf3);\n}\n\n.tnFilterPanel > header strong {\n  color: var(--text-strong, #142033);\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 1.3;\n}\n\n.tnFilterPanel > header button {\n  width: 30px;\n  min-width: 30px;\n  height: 30px;\n  min-height: 30px;\n  padding: 0;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: #667085;\n  font-size: 22px;\n  font-weight: 400;\n  line-height: 1;\n}\n\n.tnFilterPanel__body {\n  display: grid;\n  min-height: 0;\n  flex: 1 1 auto;\n  align-content: start;\n  grid-template-columns: 1fr;\n  grid-auto-rows: max-content;\n  gap: 16px;\n  padding: 18px 18px 22px;\n  overflow-y: auto;\n}\n\n.tnFilterPanel__body label,\n.tnFilterPanel__body select,\n.tnFilterPanel__body .tnDateRangePicker,\n.tnFilterPanel__body .tnFilterReset {\n  width: 100%;\n  min-width: 0;\n}\n\n.tnFilterPanel__body .sit-dp__trigger,\n.tnFilterPanel__body select {\n  width: 100%;\n  height: 40px;\n}\n\n.tnFilterPanel > footer {\n  display: flex;\n  min-height: 64px;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 14px 18px;\n  border-top: 1px solid var(--border-subtle, #e7edf3);\n  background: #fff;\n}\n\n.tnFilterPanel > footer > div {\n  display: flex;\n  gap: 8px;\n}\n\n.tnFilterClear {\n  min-height: 36px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #1a6da3;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.tnFilterPanel .sit-dp__pop {\n  position: fixed;\n  z-index: 1080;\n  top: 50%;\n  right: auto;\n  bottom: auto;\n  left: 50%;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 32px);\n  transform: translate(-50%, -50%);\n}\n\n@media (max-width: 600px) {\n  .tnFilterPanel {\n    top: 0;\n    left: 0;\n    width: 100vw;\n    max-width: none;\n    height: 100vh;\n  }\n}\n\n.tnActiveFilters {\n  display: flex;\n  min-height: 44px;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin: -4px 0 14px;\n}\n\n.tnActiveFilters span {\n  display: inline-flex;\n  min-height: 30px;\n  align-items: center;\n  gap: 4px;\n  padding: 0 10px;\n  border: 1px solid #b9dff2;\n  border-radius: 999px;\n  background: #eef8fc;\n  color: #124f76;\n  font-size: 12px;\n}\n\n.tnActiveFilters button {\n  border: 0;\n  background: transparent;\n  color: #69778a;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.tnConfirmationRequestDialog .modal-body {\n  padding: 0 !important;\n  overflow: auto;\n}\n\n.tnConfirmationRequestModal {\n  min-width: 0;\n  background: #fff;\n  color: var(--text-strong, #142033);\n}\n\n.tnConfirmationRequestModal > header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 22px 24px 18px;\n  border-bottom: 1px solid var(--border-subtle, #e7edf3);\n  background: #fff;\n}\n\n.tnConfirmationRequestModal > header h2 {\n  margin: 0;\n  color: var(--text-strong, #142033);\n  font-size: 20px;\n  font-weight: 800;\n  line-height: 1.3;\n}\n\n.tnConfirmationRequestModal > header p {\n  margin: 5px 0 0;\n  color: #667085;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.45;\n}\n\n.tnConfirmationRequestModal > header button {\n  width: 34px;\n  height: 34px;\n  flex: 0 0 auto;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  background: #f4f6f8;\n  color: #526071;\n  font-size: 23px;\n  line-height: 1;\n}\n\n.tnConfirmationRequestModal__body {\n  padding: 20px 24px 24px;\n}\n\n.tnConfirmationRequestModal__error {\n  margin: 18px 24px 0;\n  padding: 11px 13px;\n  border: 1px solid #fecaca;\n  border-radius: 9px;\n  background: #fff1f2;\n  color: #b42318;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.tnConfirmationRequestModal .programmeBookingModalHero,\n.tnConfirmationRequestModal .programmeBookingQuestionCard {\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  box-shadow: none;\n}\n\n.tnConfirmationRequestModal .programmeBookingModalHero {\n  padding: 18px;\n  background: #f8fafc;\n}\n\n.tnConfirmationRequestModal .programmeBookingQuestionCard {\n  padding: 16px;\n  background: #fff;\n}\n\n.tnConfirmationRequestModal .form-control {\n  min-height: 40px;\n  border-color: #ccd5df;\n  border-radius: 8px;\n}\n\n.tnConfirmationRequestModal__body > div > .d-flex.justify-content-end {\n  margin-top: 20px !important;\n  padding-top: 18px;\n  border-top: 1px solid var(--border-subtle, #e7edf3);\n}\n\n.tnConfirmationRequestModal__body .btn {\n  min-width: 104px;\n  min-height: 40px;\n  padding: 8px 18px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  box-shadow: none !important;\n}\n\n.tnConfirmationRequestModal__body .btn-primary {\n  border-color: #1a6da3;\n  background: #1a6da3;\n}\n\n@media (max-width: 600px) {\n  .tnConfirmationRequestModal > header,\n  .tnConfirmationRequestModal__body {\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n}\n\n/* School tournament lists: shared page shell aligned with the organiser-side reference. */\n.tnPage {\n  width: 100%;\n  max-width: none;\n  min-width: 0;\n  background: var(--surface-page, #f8fafc);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.tnPageHeader {\n  display: flex;\n  width: calc(100% + 52px);\n  height: 70px;\n  min-width: 0;\n  align-items: center;\n  gap: 28px;\n  margin: -20px -30px 0 -22px;\n  padding: 0 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.tnPageHeader > h1 {\n  flex: 0 0 auto;\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: -0.015em;\n  white-space: nowrap;\n}\n\n.tnPageHeader .tnTabs {\n  display: flex;\n  min-width: 0;\n  height: 70px;\n  flex: 1 1 auto;\n  align-self: stretch;\n  align-items: stretch;\n  gap: 26px;\n  margin: 0;\n  overflow-x: auto;\n  border: 0;\n}\n\n.tnPageHeader .tnTabs button {\n  position: relative;\n  height: auto;\n  min-height: 0;\n  flex: 0 0 auto;\n  padding: 1px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 15px;\n  font-weight: 650;\n}\n\n.tnPageHeader .tnTabs button::after {\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 3px;\n  border-radius: 3px 3px 0 0;\n  background: transparent;\n}\n\n.tnPageHeader .tnTabs button:hover,\n.tnPageHeader .tnTabs button.isActive {\n  color: var(--blue-600, #1a6da3);\n}\n\n.tnPageHeader .tnTabs button.isActive::after {\n  bottom: 0;\n  height: 3px;\n  background: var(--blue-500, #227ebd);\n}\n\n.tnPageHeader .tnTabs span {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n}\n\n.tnPageHeader .tnTabs button.isActive span {\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.tnPageHeader .tnTabs span.tnTabs__unread {\n  background: var(--amber-100, #ffedc2);\n  color: var(--amber-800, #8a4b08);\n}\n\n.tnSummaryStrip {\n  display: flex;\n  width: calc(100% + 52px);\n  min-width: 0;\n  align-items: center;\n  gap: 8px;\n  margin: 0 -30px 0 -22px;\n  padding: 10px 28px 11px;\n  overflow-x: auto;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n  scrollbar-width: thin;\n}\n\n.tnSummaryChip {\n  display: inline-flex;\n  min-height: 34px;\n  flex: 0 0 auto;\n  align-items: center;\n  padding: 6px 11px;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  font: inherit;\n  text-align: left;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: border-color 140ms ease, filter 140ms ease, transform 140ms ease;\n}\n\n.tnSummaryChip:hover,\n.tnSummaryChip:focus-visible {\n  filter: brightness(0.985);\n  transform: translateY(-1px);\n  outline: none;\n}\n\n.tnSummaryChip__copy {\n  display: inline-flex;\n  min-width: 0;\n  align-items: baseline;\n  gap: 5px;\n  white-space: nowrap;\n}\n\n.tnSummaryChip small,\n.tnSummaryChip strong {\n  display: inline;\n  white-space: nowrap;\n}\n\n.tnSummaryChip small {\n  color: inherit;\n  font-size: 12px;\n  font-weight: 650;\n  line-height: 1.2;\n  opacity: 0.78;\n}\n\n.tnSummaryChip strong {\n  color: inherit;\n  font-size: 12px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.tnSummaryChip.is-date {\n  border-color: #f3d49a;\n  background: #fff7e8;\n  color: #8b570a;\n}\n\n.tnSummaryChip.is-upcoming {\n  border-color: #c9e0f1;\n  background: #eef6fc;\n  color: #155d8c;\n}\n\n.tnSummaryChip.is-invites {\n  border-color: #f5c9b5;\n  background: #fff3ed;\n  color: #a74418;\n}\n\n.tnSummaryChip.is-requests {\n  border-color: #d9d1f3;\n  background: #f5f2ff;\n  color: #6548a8;\n}\n\n.tnSummaryChip.is-waiting {\n  border-color: #bfe5d0;\n  background: #eefaf3;\n  color: #287447;\n}\n\n.tnMain {\n  width: 100%;\n  max-width: none;\n  padding: 14px 12px 36px;\n}\n\n.tnListPanel {\n  width: 100%;\n  min-width: 0;\n  overflow: visible;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-sm, 0 1px 2px rgba(15, 23, 42, 0.04));\n}\n\n.tnListPanel .tnToolbar {\n  display: block;\n  margin: 0;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.tnListPanel .tnToolbarHead {\n  margin: 0;\n}\n\n.tnListPanel .tnToolbarMain,\n.tnListPanel .tnSectionTitleRow {\n  width: 100%;\n}\n\n.tnListPanel .tnSectionTitleRow {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.tnListPanel .tnSectionTitleRow h2 {\n  margin-right: 2px;\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.tnListCount,\n.tnResponseBadge {\n  display: inline-flex;\n  min-width: 24px;\n  min-height: 24px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b) !important;\n  font-size: 11px !important;\n  font-weight: 800 !important;\n}\n\n.tnListPanel .tnSearch {\n  position: relative;\n  width: min(320px, 100%);\n  height: 40px;\n  margin-left: 4px;\n  padding: 0 38px 0 12px;\n  border-color: var(--border-default, #cbd5e1);\n  border-radius: 8px;\n}\n\n.tnListPanel .tnSearch:focus-within {\n  border-color: var(--blue-500, #227ebd);\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.13);\n}\n\n.tnListPanel .tnSearch > button {\n  position: absolute;\n  top: 50%;\n  right: 7px;\n  display: inline-flex;\n  width: 26px;\n  height: 26px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  transform: translateY(-50%);\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.tnListPanel .tnSearch > button:hover {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n\n.tnListPanel .tnIconBtn,\n.tnListPanel .tnColumnsBtn {\n  height: 40px;\n  min-height: 40px;\n  border-color: var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.tnListPanel .tnIconBtn:hover,\n.tnListPanel .tnIconBtn.isOn,\n.tnListPanel .tnColumnsBtn:hover,\n.tnListPanel .tnColumnsBtn.isOpen {\n  border-color: var(--blue-500, #227ebd);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.tnListPanel .tnActiveFilters {\n  min-height: 46px;\n  margin: 0;\n  padding: 8px 16px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.tnListPanel .tnActiveFilters > span {\n  min-height: 28px;\n  padding: 0 8px 0 10px;\n  border-color: #b9dff2;\n  background: #eef8fc;\n  color: #124f76;\n}\n\n.tnListPanel .tnActiveFilters > span > button {\n  display: inline-flex;\n  width: 18px;\n  min-width: 18px;\n  height: 18px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: currentColor;\n  font-size: 15px;\n  line-height: 1;\n}\n\n.tnListPanel .tnActiveFilters > span > button:hover {\n  background: rgba(21, 93, 140, 0.12);\n}\n\n.tnListPanel .tnActiveFilters > .tnActiveFilters__clear {\n  padding: 0 4px;\n  color: var(--blue-700, #155d8c);\n  font-size: 12px;\n  font-weight: 750;\n}\n\n.tnFilterChips {\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n.tnFilterChips legend {\n  margin: 0 0 8px;\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.tnFilterChips > div {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n\n.tnFilterChips button {\n  min-height: 32px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 999px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 650;\n}\n\n.tnFilterChips button:hover {\n  border-color: #84b9d8;\n  background: #f5fafc;\n}\n\n.tnFilterChips button.isSelected {\n  border-color: var(--blue-500, #227ebd);\n  background: var(--blue-500, #227ebd);\n  color: #fff;\n}\n\n.tnListPanel .tnFilterPanel {\n  box-shadow: -100vw 0 0 100vw rgba(15, 23, 42, 0.22), -12px 0 34px rgba(15, 23, 42, 0.14);\n}\n\n.tnListPanel .tnBtnPrimary:hover:not(:disabled) {\n  border-color: var(--blue-700, #155d8c);\n  background: var(--blue-700, #155d8c);\n  color: #fff;\n}\n\n.tnListPanel .tnArchiveSegment,\n.tnListPanel .tnSelection {\n  margin: 12px 16px;\n}\n\n.tnListPanel .tnTableCard {\n  margin: 0;\n  overflow: hidden;\n  border-width: 1px 0 0;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.tnListPanel .tnTable tbody tr,\n.tnListPanel .tnTable td {\n  height: 56px;\n}\n\n.tnListPanel .tnTable tbody tr {\n  cursor: pointer;\n}\n\n.tnListPanel .tnEmpty {\n  height: 220px;\n  color: var(--text-muted, #64748b);\n  font-size: 14px;\n  text-align: center;\n}\n\n.tnListPanel .tnListPagination .bPagination--modern {\n  display: flex;\n  min-height: 58px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin: 0;\n  padding: 10px 16px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  border-right: 0;\n  border-bottom: 0;\n  border-left: 0;\n}\n\n@media (max-width: 600px) {\n  .tnListPagination .bPagination--modern { flex-wrap: wrap; }\n  .tnListPagination .bPagination__pages { flex-wrap: wrap; }\n}\n\n.tnPagination__info {\n  min-width: 94px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  font-weight: 650;\n  text-align: center;\n}\n\n.tnListPanel .tnPageBtn {\n  min-width: 84px;\n}\n\n.tnListPanel .tnColumnsMenu {\n  z-index: 1070;\n  top: 46px;\n}\n\n@media (max-width: 900px) {\n  .tnPageHeader {\n    height: auto;\n    min-height: 70px;\n    flex-wrap: wrap;\n    gap: 0 16px;\n    padding-top: 10px;\n  }\n\n  .tnPageHeader .tnTabs {\n    width: 100%;\n    height: 42px;\n    flex-basis: 100%;\n    order: 3;\n  }\n}\n\n@media (max-width: 760px) {\n  .tnPageHeader {\n    width: calc(100% + 44px);\n    margin-right: -22px;\n    margin-left: -22px;\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n\n  .tnMain {\n    padding: 10px 8px 24px;\n  }\n\n  .tnSummaryStrip {\n    width: calc(100% + 44px);\n    margin-right: -22px;\n    margin-left: -22px;\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n\n  .tnListPanel .tnSectionTitleRow {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .tnListPanel .tnSectionTitleRow h2,\n  .tnListPanel .tnListCount,\n  .tnListPanel .tnResponseBadge {\n    align-self: flex-start;\n  }\n\n  .tnListPanel .tnSearch,\n  .tnListPanel .tnIconBtn,\n  .tnListPanel .tnColumns,\n  .tnListPanel .tnColumnsBtn {\n    width: 100%;\n  }\n}\n.tnReportPicker {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 22px;\n}\n\n.tnReportDialog .modal-content {\n  overflow: hidden;\n  border: 0;\n  border-radius: 16px;\n  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.22);\n}\n\n.tnReportDialog .modal-body {\n  padding: 0;\n}\n\n.tnReportPicker__heading {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding-bottom: 4px;\n}\n\n.tnReportPicker__heading > span {\n  width: 42px;\n  height: 42px;\n  display: inline-flex;\n  flex: 0 0 42px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  background: #eaf2ff;\n  color: #2463a7;\n}\n\n.tnReportPicker h2,\n.tnReportPicker p {\n  margin: 0;\n}\n\n.tnReportPicker > .tnBtn {\n  display: grid;\n  grid-template-columns: 38px minmax(0, 1fr);\n  height: auto;\n  min-height: 70px;\n  align-items: center;\n  justify-content: stretch;\n  gap: 12px;\n  padding: 14px 16px;\n  text-align: left;\n}\n\n.tnReportPicker__optionIcon {\n  width: 38px;\n  height: 38px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  background: #f0f5fb;\n  color: #2463a7;\n}\n\n.tnReportPicker__optionIcon svg {\n  display: block;\n  flex: 0 0 auto;\n}\n\n.tnReportPicker__optionCopy {\n  display: flex;\n  min-width: 0;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 2px;\n  line-height: 1.35;\n}\n\n.tnReportPicker__optionCopy strong,\n.tnReportPicker__optionCopy small {\n  display: block;\n  margin: 0;\n}\n\n.tnReportPicker > .tnBtn small {\n  color: #667085;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.tnReportDialog form {\n  max-height: min(78vh, 720px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 22px 24px;\n  color: #172033;\n}\n\n.tnReportDialog .bReportFormTitle {\n  position: relative;\n  margin: -22px -24px 18px;\n  padding: 20px 54px 18px 62px;\n  border-bottom: 1px solid #e7edf4;\n  background: #f8fafc;\n  color: #172033;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.tnReportDialog .bReportFormTitle::before {\n  content: '';\n  position: absolute;\n  top: 15px;\n  left: 20px;\n  width: 32px;\n  height: 32px;\n  border-radius: 9px;\n  background: #eaf2ff url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%232463a7' stroke-width='1.8'%3E%3Cpath d='M6 2h8l4 4v16H6zM14 2v5h5M9 12h6M9 16h6'/%3E%3C/svg%3E\") center/18px no-repeat;\n}\n\n.tnReportDialog form > .mb-3.mt-3 {\n  margin: 0 0 18px !important;\n  color: #667085;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.tnReportDialog .form-group,\n.tnReportDialog .form-check {\n  margin: 0 !important;\n  padding: 11px 0 !important;\n  border-bottom: 1px solid #eef2f6;\n}\n\n.tnReportDialog .form-group > label {\n  display: block;\n  margin-bottom: 6px;\n  color: #344054;\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.tnReportDialog .react-datepicker-wrapper,\n.tnReportDialog .react-datepicker__input-container {\n  width: 100%;\n}\n\n.tnReportDialog .form-control {\n  height: 40px;\n  border: 1px solid #cfd8e3;\n  border-radius: 9px;\n  box-shadow: none;\n  font-size: 14px;\n}\n\n.tnReportDialog .tournamentReportFormModern__dateRange {\n  margin-bottom: 18px;\n}\n\n.tnReportDialog .tournamentReportFormModern__dateRange .sit-dp {\n  width: 100%;\n}\n\n.tnReportDialog .tournamentReportFormModern__options {\n  overflow: hidden;\n  border: 1px solid #e4eaf1;\n  border-radius: 12px;\n  background: #fff;\n}\n\n.tnReportDialog .tournamentReportFormModern__option {\n  min-height: 58px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  padding: 10px 13px;\n  border-bottom: 1px solid #edf1f5;\n}\n\n.tnReportDialog .tournamentReportFormModern__option:last-child {\n  border-bottom: 0;\n}\n\n.tnReportDialog .tournamentReportFormModern__option > div {\n  display: flex;\n  min-width: 0;\n  flex-direction: column;\n  gap: 2px;\n  text-align: left;\n}\n\n.tnReportDialog .tournamentReportFormModern__option strong {\n  color: #27364b;\n  font-size: 13.5px;\n  font-weight: 650;\n}\n\n.tnReportDialog .tournamentReportFormModern__option small {\n  color: #667085;\n  font-size: 11.5px;\n  line-height: 1.35;\n}\n\n.tnReportDialog .form-group .d-flex,\n.tnReportDialog .form-check .d-flex {\n  align-items: center;\n}\n\n.tnReportDialog .form-group > .d-flex,\n.tnReportDialog .form-check > .d-flex {\n  min-height: 38px;\n  flex-direction: row-reverse;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.tnReportDialog .form-group > .d-flex > .d-flex,\n.tnReportDialog .form-check > .d-flex > .d-flex {\n  min-width: 0;\n  flex: 1 1 auto;\n  align-items: flex-start;\n  justify-content: flex-start !important;\n  flex-direction: column;\n  gap: 2px;\n  text-align: left;\n}\n\n.tnReportDialog .form-check-label {\n  width: 100%;\n  flex: none;\n  margin: 0;\n  padding-left: 0 !important;\n  color: #344054;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.35;\n  text-align: left;\n}\n\n.tnReportDialog .eFieldInlineHint {\n  display: block;\n  width: 100%;\n  margin: 0;\n  color: #667085;\n  font-size: 11.5px;\n  font-weight: 400;\n  line-height: 1.4;\n  text-align: left;\n}\n\n.tnReportDialog .sit-switch {\n  flex: 0 0 auto;\n  margin: 0;\n}\n\n.tnReportDialog .sit-switch__track {\n  width: 38px;\n  height: 22px;\n  border: 1px solid #b8c4d3;\n  border-radius: 999px;\n  background: #cbd5e1;\n  box-sizing: border-box;\n}\n\n.tnReportDialog .sit-switch__thumb {\n  width: 18px;\n  height: 18px;\n  border: 1px solid rgba(23, 32, 51, 0.12);\n  border-radius: 50%;\n  background: #fff;\n  box-sizing: border-box;\n  box-shadow: 0 1px 3px rgba(23, 32, 51, 0.24);\n}\n\n.tnReportDialog .sit-switch input:checked + .sit-switch__track {\n  border-color: #2463a7;\n  background: #2463a7;\n}\n\n.tnReportDialog .sit-switch input:focus-visible + .sit-switch__track {\n  box-shadow: 0 0 0 3px rgba(36, 99, 167, 0.2);\n}\n\n.tnReportDialog .tournamentReportFormModern__footer {\n  position: sticky;\n  bottom: -22px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 9px;\n  margin: 18px -24px -22px;\n  padding: 14px 24px;\n  border-top: 1px solid #e7edf4;\n  background: #fbfdff;\n}\n\n.tnReportDialog .tournamentReportFormModern__footer .btn {\n  border: 0;\n  border-radius: 9px;\n  padding: 9px 17px;\n  font-size: 14px;\n  font-weight: 650;\n}\n\n.tnReportDialog .tournamentReportFormModern__footer .btn-secondary {\n  border: 1px solid #d7dee8;\n  background: #fff;\n  color: #344054;\n}\n\n.tnReportDialog .tournamentReportFormModern__footer .btn-primary {\n  background: #2463a7;\n  color: #fff;\n}\n\n.tnReportPicker__footer {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
